{
	"actions": {
		"title": "Actions",
		"save": "Enregistrer",
		"edit": "Modifier",
		"delete": "Supprimer",
		"remove": "Retirer",
		"deleting": "Suppression",
		"see": "Voir",
		"open": "Ouvrir",
		"back": "Retour",
		"close": "Fermer",
		"cancel": "Annuler",
		"download": "Télécharger"
	},
	"theme": {
		"light": "Clair",
		"dark": "Sombre",
		"toggle": "Changer de thème"
	},
	"language": "Langue",
	"auth": {
		"pets": "Animaux de compagnie",
		"logoAriaLabel": "Logo Pets",
		"links": {
			"forgotPassword": "Mot de passe oublié",
			"createAccount": "Créer un compte",
			"backToLogin": "Retour à la connexion",
			"alreadyHaveAccount": "J’ai déjà un compte"
		},
		"login": {
			"title": "Connexion",
			"submit": "Se connecter",
			"loadingAria": "Connexion"
		},
		"forgotPassword": {
			"title": "Mot de passe oublié",
			"submit": "Envoyer le token",
			"loadingAria": "Envoi du token"
		},
		"resetPassword": {
			"title": "Réinitialiser le mot de passe",
			"submit": "Enregistrer le nouveau mot de passe",
			"loadingAria": "Enregistrement du nouveau mot de passe"
		},
		"signup": {
			"title": "Créer un compte",
			"submit": "Créer un compte",
			"loadingAria": "Création du compte",
			"termsLabel": "J’ai lu et j’accepte les",
			"termsLinkLabel": "conditions d’utilisation",
			"options": {
				"referralSource": {
					"indicacao": "Recommandation",
					"redesSociais": "Réseaux sociaux",
					"pesquisaGoogle": "Recherche Google",
					"veterinario": "Vétérinaire",
					"outro": "Autre"
				}
			}
		},
		"verify": {
			"title": "Confirmer l’e-mail",
			"submit": "Confirmer",
			"submitAria": "Confirmer l’e-mail",
			"loadingAria": "Confirmation de l’e-mail",
			"resend": "Renvoyer le token",
			"resending": "Renvoi…",
			"resendIn": "Renvoyer dans { seconds }s"
		},
		"acceptInvite": {
			"title": {
				"loading": "Accepter l’invitation",
				"needPassword": "Finalisez votre accès",
				"redirecting": "Redirection…"
			},
			"info": {
				"needPassword": "Créez un mot de passe pour terminer l’inscription et accéder à l’animal.",
				"invitedEmail": "E-mail de l’invitation : <strong>{email}</strong>"
			},
			"loading": {
				"validating": "Validation de l’invitation…",
				"redirecting": "Redirection…"
			},
			"submit": "Terminer et accéder",
			"submitAria": "Terminer l’inscription et accéder",
			"retry": "Réessayer",
			"errors": {
				"missing_token": {
					"title": "Lien invalide",
					"message": "Le lien d’invitation est incomplet. Demandez une nouvelle invitation pour accéder au système."
				},
				"invalid_token": {
					"title": "Invitation invalide",
					"message": "Demandez une nouvelle invitation pour accéder au système."
				},
				"invalid_invite": {
					"title": "Invitation invalide",
					"message": "Les données de cette invitation sont incomplètes. Demandez une nouvelle invitation au tuteur pour accéder au système."
				},
				"invite_expired": {
					"title": "Invitation expirée",
					"message": "Cette invitation a expiré. Demandez une nouvelle invitation au tuteur pour accéder au système."
				},
				"invite_revoked": {
					"title": "Invitation annulée",
					"message": "Cette invitation a été annulée par le tuteur. Demandez une nouvelle invitation pour accéder au système."
				},
				"invite_rejected": {
					"title": "Invitation refusée",
					"message": "Cette invitation a été refusée. Demandez une nouvelle invitation au tuteur si vous souhaitez toujours accéder."
				},
				"invite_used": {
					"title": "Invitation déjà utilisée",
					"message": "Cette invitation a déjà été acceptée. Connectez-vous pour accéder au système."
				},
				"user_blocked": {
					"title": "Accès bloqué",
					"message": "Votre compte n’est pas autorisé à accéder. Contactez le tuteur ou le support."
				},
				"pet_not_found": {
					"title": "Animal indisponible",
					"message": "L’animal de cette invitation n’est plus disponible. Demandez une nouvelle invitation au tuteur."
				},
				"bad_request": {
					"title": "Traitement impossible",
					"message": "Impossible de traiter l’invitation. Réessayez d’ouvrir le lien ou demandez une nouvelle invitation."
				},
				"db_error": {
					"title": "Erreur d’enregistrement",
					"message": "Une erreur s’est produite lors de la finalisation de l’inscription. Réessayez dans quelques instants."
				},
				"no_jwt": {
					"title": "Impossible de terminer",
					"message": "Impossible de démarrer votre session. Réessayez ou connectez-vous."
				},
				"unauthorized": {
					"title": "Session expirée",
					"message": "Votre session a expiré ou est invalide. Réessayez ou connectez-vous."
				},
				"generic": {
					"title": "Erreur lors de l’acceptation de l’invitation",
					"message": "Impossible de finaliser l’acceptation de l’invitation. Réessayez dans quelques instants."
				}
			}
		},
		"rejectInvite": {
			"title": {
				"loading": "Refuser l’invitation",
				"confirm": "Refuser l’invitation",
				"done": "Invitation refusée",
				"error": "Impossible de refuser"
			},
			"info": {
				"confirm": "Voulez-vous vraiment refuser cette invitation pour accéder à un animal ?",
				"fromTutor": "Envoyé par {name}"
			},
			"loading": {
				"validating": "Validation de l’invitation…"
			},
			"submit": "Refuser l’invitation",
			"submitting": "Refus en cours…",
			"success": "Invitation refusée avec succès. Vous ne recevrez plus de notifications à ce sujet.",
			"errors": {
				"missing_token": "Le lien est incomplet. Ouvrez à nouveau l’e-mail d’invitation.",
				"invalid_token": "Cette invitation n’est pas valide ou a déjà été traitée.",
				"invalid_invite": "Les données de cette invitation sont incomplètes.",
				"invite_expired": "Cette invitation a expiré.",
				"invite_revoked": "Cette invitation a été annulée par le tuteur.",
				"invite_rejected": "Cette invitation a déjà été refusée.",
				"invite_used": "Cette invitation a déjà été acceptée.",
				"generic": "Impossible de refuser l’invitation. Réessayez dans quelques instants."
			}
		},
		"errors": {
			"invalidCredentials": "Identifiants invalides",
			"emailNotVerified": "Confirmez votre e-mail avant de vous connecter",
			"accountDeleted": "Ce compte a été supprimé. Contactez le support.",
			"accountBlocked": "Ce compte est bloqué. Contactez le support.",
			"loginFailed": "Échec de la connexion",
			"emailInUse": "Cet e-mail est déjà utilisé",
			"passwordConfirmMismatch": "Les mots de passe ne correspondent pas",
			"signupFailed": "Échec de la création du compte",
			"tokenExpired": "Le token a expiré. Demandez-en un autre.",
			"tokenInvalid": "Token invalide",
			"verifyTokenExpired": "Le token a expiré. Demandez-en un nouveau.",
			"verifyTokenInvalid": "Token invalide",
			"verifyResendEmailInvalid": "Saisissez un e-mail valide pour renvoyer",
			"verifyResendFailed": "Échec du renvoi du token"
		},
		"messages": {
			"forgotPasswordInfo": "Si un compte existe pour cet e-mail, nous enverrons un token.",
			"resetPasswordSuccess": "Mot de passe mis à jour. Vous pouvez vous connecter.",
			"verifySuccess": "E-mail confirmé. Vous pouvez vous connecter.",
			"verifyResendSuccess": "Nous avons envoyé un nouveau token à votre e-mail."
		}
	},
	"emptyState": {
		"generic": {
			"default": {
				"title": "Aucun résultat trouvé",
				"description": "Essayez d'ajuster les filtres ou de créer un nouvel élément.",
				"action": "Créer un élément",
				"actionAriaLabel": "Créer un nouvel élément"
			},
			"search": {
				"title": "Aucun résultat",
				"description": "Essayez de modifier les filtres ou de rechercher un autre terme."
			},
			"permission": {
				"title": "Action indisponible",
				"description": "Vous n'avez pas encore l'autorisation de créer cet élément."
			}
		},
		"pets": {
			"user": {
				"title": "Ravi de vous voir ici !",
				"description": "Enregistrez votre premier animal pour commencer le suivi.",
				"action": "+ Animal",
				"actionAriaLabel": "Enregistrer un nouvel animal"
			},
			"userFiltered": {
				"title": "Aucun animal trouvé",
				"description": "Aucun animal ne correspond aux filtres actuels. Essayez d'effacer la recherche ou de changer espèce/sexe."
			},
			"vet": {
				"title": "Aucun animal partagé pour le moment",
				"description": "Lorsqu'un tuteur partagera un animal avec vous, il apparaîtra ici."
			},
			"master": {
				"title": "Aucun animal trouvé",
				"description": "Essayez de réinitialiser les filtres ou de sélectionner un tuteur spécifique."
			},
			"masterMine": {
				"title": "Vous n'avez aucun animal enregistré",
				"description": "Enregistrez un animal ou changez la portée pour voir les animaux d'autres tuteurs."
			},
			"masterMineFiltered": {
				"title": "Aucun animal trouvé",
				"description": "Aucun de vos animaux ne correspond aux filtres actuels. Essayez d'effacer la recherche ou de changer espèce/sexe."
			},
			"masterWithTutor": {
				"title": "Aucun animal trouvé pour ce tuteur",
				"description": "Essayez de réinitialiser les filtres ou de sélectionner un autre tuteur."
			},
			"masterWithTutorFiltered": {
				"title": "Aucun animal trouvé pour ce tuteur",
				"description": "Aucun animal de ce tuteur ne correspond aux filtres actuels. Essayez d'effacer la recherche ou de changer espèce/sexe."
			},
			"masterAll": {
				"title": "Aucun animal trouvé",
				"description": "Aucun animal d'autres tuteurs ne correspond aux filtres actuels."
			},
			"masterAllFiltered": {
				"title": "Aucun animal trouvé",
				"description": "Aucun animal d'autres tuteurs ne correspond aux filtres actuels."
			},
			"onlyWithAlerts": {
				"title": "Aucun animal avec alerte",
				"description": "Aucun animal avec des alertes actives n'a été trouvé pour les filtres sélectionnés."
			}
		}
	},
	"form-fields": {
		"email": "E-mail",
		"emailPlaceholder": "votre@email.com",
		"password": "Mot de passe",
		"passwordPlaceholder": "Votre mot de passe",
		"token": "Token",
		"tokenPlaceholder": "Collez le token reçu",
		"newPassword": "Nouveau mot de passe",
		"newPasswordPlaceholder": "Au moins 8 caractères",
		"passwordConfirm": "Confirmer le mot de passe",
		"passwordConfirmPlaceholder": "Répétez le mot de passe",
		"fullName": "Nom complet",
		"fullNamePlaceholder": "Votre nom",
		"preferredName": "Nom préféré",
		"preferredNamePlaceholder": "Comment vous souhaitez être appelée",
		"referralSource": "Comment nous avez-vous connus ?",
		"referralSourcePlaceholder": "Sélectionnez",
		"referralDetail": "Qui vous a recommandé, ou où nous avez-vous trouvés ?",
		"referralDetailPlaceholder": "Ex. : Instagram, ami, clinique…",
		"measuredAt": "Date de pesée",
		"weightKg": "Poids (kg)",
		"weightKgPlaceholder": "Ex. : 2,50"
	},
	"validation": {
		"required": "*Champ obligatoire",
		"requiredTerms": "*Acceptez les conditions pour continuer",
		"min": "*Saisissez une valeur supérieure ou égale au minimum autorisé",
		"minlength": "*Minimum {requiredLength} caractères",
		"invalidEmail": "*Adresse e-mail invalide",
		"invalidValue": "*Valeur invalide",
		"invalidDate": "*Date invalide",
		"futureDate": "*La date ne peut pas être postérieure à aujourd'hui",
		"adoptionBeforeBirth": "*La date d'adoption ne peut pas être antérieure à la naissance",
		"passwordMismatch": "*Les mots de passe ne correspondent pas"
	},
	"form-filter": {
		"title": {
			"list": "Liste de filtres",
			"filterOf": "Filtres {tipo}"
		},
		"placeholders": {
			"name": "Rechercher par nom",
			"species": {
				"title": "Espèce"
			},
			"sex": {
				"title": "Sexe"
			},
			"tutor": {
				"selectTutor": "Sélectionner un tuteur",
				"scope": "Portée",
				"scopeMine": "Mes animaux",
				"scopeAll": "Tous les tuteurs",
				"search": "Rechercher un propriétaire",
				"choose": "Choisissez un tuteur",
				"noneFound": "Aucun tuteur disponible",
				"lookingPetFrom": "Affichage des animaux de :",
				"noneSelectedMine": "Affichage de vos animaux.",
				"noneSelectedAll": "Affichage des animaux de tous les tuteurs.",
				"totalPets": "Nombre total d'animaux de compagnie :"
			}
		},
		"buttons": {
			"clear": "Effacer",
			"clearSelection": "Effacer la sélection",
			"refreshList": "Actualiser la liste",
			"onylWithAlerts": "Uniquement les animaux avec alertes"
		},
		"total": "{total, plural, =0{<strong>animaux de compagnie non admis</strong>} =1{<strong>{total}</strong> animal de compagnie} other{<strong>{total}</strong> animaux de compagnie}}"
	},
	"home": {
		"alerts": {
			"title": "Alertes",
			"refresh": "Actualiser",
			"refreshing": "Actualisation...",
			"viewMore": "Voir plus",
			"pageTitle": "Alertes",
			"pageSubtitle": "Toutes les alertes de vos animaux",
			"pageTitlePet": "Alertes de l’animal",
			"pageSubtitlePet": "Alertes et éléments en attente pour cet animal",
			"tabs": {
				"all": "Tous",
				"danger": "Urgents",
				"warn": "Bientôt",
				"info": "Informatifs"
			},
			"groups": {
				"danger": "Urgentes",
				"warn": "Bientôt",
				"info": "Informations"
			},
			"empty": {
				"title": "Tout est à jour !",
				"description": "Aucune alerte n'a été trouvée pour les animaux sélectionnés."
			},
			"preventives": {
				"vermifugo": "Vermifuge",
				"antiPulgas": "Antipuces"
			},
			"items": {
				"birthday": "Anniversaire",
				"birthdayWithYears": "Joyeux anniversaire ! {years} ans",
				"vaccine": "Vaccin {type}",
				"vaccineAnnualSoon": "La vaccination annuelle approche",
				"vaccineAnnualOverdue": "Vaccination annuelle en retard",
				"vaccineIndividualSoon": "Vaccin {name} bientôt",
				"vaccineIndividualOverdue": "Vaccin {name} en retard",
				"vaccineMissing": "Aucun vaccin enregistré",
				"glycemia": "Mesure de glycémie",
				"treatment": "{name}",
				"preventive": "{kind}",
				"preventiveFallback": "Préventif",
				"visit": "Consultation",
				"weightNever": "Jamais pesé",
				"weightStale": "Pas de pesée depuis plus de 6 mois"
			},
			"time": {
				"today": "aujourd'hui",
				"inDays": "dans {days} jours",
				"inDaysWithDate": "dans {days} jours · {date}",
				"overdue": "en retard de {days} jours",
				"overdueWithDate": "il y a {days} jours · prévue le {date}",
				"dueToday": "aujourd'hui · {date}",
				"pending": "En attente",
				"lastWeighing": "dernière : {date}",
				"withClock": "{label} · {time}"
			}
		}
	},
	"list": {
		"errors": {
			"loadPets": "Impossible de charger les animaux.",
			"loadAlerts": "Impossible de charger les alertes.",
			"loadTutors": "Impossible de charger les tuteurs.",
			"deletePet": "Impossible de supprimer l'animal.",
			"leaveSharedPet": "Impossible de retirer l'animal de votre liste.",
			"loadMorePets": "Impossible de charger plus d'animaux."
		},
		"loadError": {
			"title": "Impossible de charger les animaux",
			"description": "Vérifiez votre connexion et réessayez.",
			"retry": "Réessayer"
		},
		"loadingMorePets": "Chargement d'autres animaux...",
		"loadingPetsAria": "Chargement des animaux",
		"petCard": {
			"tutor": "Tuteur",
			"deleteAria": "Supprimer l'animal",
			"leaveAria": "Retirer l'animal de la liste",
			"fallbackName": "Animal"
		},
		"deletePet": {
			"title": "Supprimer l'animal ?",
			"contentWithName": "Voulez-vous vraiment supprimer \"{name}\" ?",
			"contentGeneric": "Voulez-vous vraiment supprimer cet animal ?",
			"confirm": "Supprimer",
			"cancel": "Annuler"
		},
		"leaveSharedPet": {
			"title": "Retirer l'animal de votre liste ?",
			"contentWithName": "Voulez-vous vraiment retirer \"{name}\" de votre liste ? Vous perdrez l'accès à cet animal.",
			"contentGeneric": "Voulez-vous vraiment retirer cet animal de votre liste ?",
			"confirm": "Retirer",
			"cancel": "Annuler",
			"success": "Animal retiré de votre liste."
		},
		"vetInvites": {
			"title": "Animaux à approuver",
			"count": "{count, plural, =0{aucune invitation} =1{1 invitation} other{{count} invitations}}",
			"refresh": "Actualiser",
			"close": "Fermer",
			"ok": "Ok",
			"approve": "Approuver",
			"reject": "Refuser",
			"columns": {
				"pet": "Animal",
				"tutor": "Tuteur",
				"status": "Statut",
				"actions": "Actions"
			},
			"emptyTitle": "Aucune invitation trouvée",
			"emptyDescription": "Lorsqu'un tuteur partagera un animal avec vous, il apparaîtra ici.",
			"emailMissing": "Impossible d'identifier l'e-mail de l'utilisateur dans le token.",
			"loadFailed": "Impossible de charger les invitations.",
			"approveSuccess": "Accès approuvé.",
			"approveFailed": "Impossible d'approuver l'accès.",
			"rejectTitle": "Refuser l'invitation ?",
			"rejectContent": "Vous n'aurez pas accès à \"{petName}\". Tuteur : {tutor}.",
			"rejectSuccess": "Invitation refusée.",
			"rejectFailed": "Impossible de refuser l'invitation.",
			"status": {
				"pending": "En attente",
				"expired": "Expiré",
				"accepted": "Accepté",
				"revoked": "Annulé",
				"unknown": "—"
			}
		},
		"vaccines": {
			"loading": "Chargement des vaccins",
			"close": "Fermer",
			"ok": "Ok",
			"fallbackName": "Vaccin",
			"filters": {
				"searchLabel": "Vaccin",
				"searchPlaceholder": "Filtrer par vaccin ou marque",
				"typeLabel": "Type",
				"typePlaceholder": "Type de vaccin",
				"typeClearAria": "Effacer le type de vaccin",
				"typeSearchPlaceholder": "Rechercher un type de vaccin",
				"typeSearchAria": "Rechercher un type de vaccin",
				"typeEmpty": "Aucun type trouvé",
				"productLabel": "Produit",
				"productPlaceholder": "Produit / marque commerciale",
				"productClearAria": "Effacer le produit",
				"productSearchPlaceholder": "Rechercher un produit",
				"productSearchAria": "Rechercher un produit",
				"productEmpty": "Aucun produit trouvé"
			},
			"columns": {
				"vaccine": "Vaccin",
				"brand": "Marque",
				"dose": "Dose",
				"administeredAt": "Administré le",
				"nextDoseAt": "Prochaine dose",
				"professional": "Vétérinaire",
				"clinic": "Clinique",
				"context": "Contexte",
				"location": "Lieu",
				"notes": "Notes",
				"actions": "Actions"
			},
			"unknown": "Non renseigné",
			"empty": {
				"title": "Aucun vaccin enregistré",
				"description": "Et si vous planifiiez le prochain ? Protégez votre animal !"
			},
			"noResults": {
				"title": "Aucun vaccin trouvé",
				"description": "Essayez d'ajuster les filtres pour trouver ce que vous cherchez."
			},
			"actions": {
				"editAria": "Modifier le vaccin",
				"deleteAria": "Supprimer le vaccin"
			},
			"delete": {
				"title": "Supprimer l'application de vaccin ?",
				"contentWithName": "Voulez-vous vraiment supprimer \"{name}\" ?",
				"contentGeneric": "Voulez-vous vraiment supprimer cette application de vaccin ?",
				"confirm": "Supprimer",
				"cancel": "Annuler",
				"success": "Vaccin supprimé avec succès."
			},
			"errors": {
				"load": "Impossible de charger les vaccins.",
				"loadTypes": "Impossible de charger les types de vaccin.",
				"loadProducts": "Impossible de charger les produits de vaccin.",
				"delete": "Impossible de supprimer le vaccin."
			}
		},
		"preventives": {
			"loading": "Chargement des préventifs",
			"protectionDays": "{days} jours",
			"protectionMonths": "{months} mois",
			"filters": {
				"searchLabel": "Préventif",
				"searchPlaceholder": "Filtrer par produit ou type (collier, pipette...)",
				"kindLabel": "Type",
				"kindPlaceholder": "Lequel",
				"kindClearAria": "Effacer le type"
			},
			"columns": {
				"kind": "Type",
				"method": "Méthode",
				"product": "Produit",
				"appliedAt": "Appliquée le",
				"nextDueAt": "Prochaine dose",
				"protection": "Protection",
				"notes": "Notes",
				"actions": "Actions"
			},
			"empty": {
				"title": "Aucun préventif enregistré",
				"description": "Ajoutez anti-puces et vermifuge pour suivre les doses !"
			},
			"noResults": {
				"title": "Aucun préventif trouvé",
				"description": "Essayez d'ajuster les filtres pour trouver ce que vous cherchez."
			},
			"actions": {
				"editAria": "Modifier le préventif",
				"deleteAria": "Supprimer le préventif"
			},
			"delete": {
				"title": "Supprimer le préventif ?",
				"contentWithName": "Voulez-vous vraiment supprimer \"{name}\" ?",
				"contentGeneric": "Voulez-vous vraiment supprimer ce préventif ?",
				"confirm": "Supprimer",
				"cancel": "Annuler",
				"success": "Préventif supprimé avec succès."
			},
			"errors": {
				"load": "Impossible de charger les préventifs.",
				"delete": "Impossible de supprimer le préventif."
			}
		},
		"treatments": {
			"loading": "Chargement des traitements",
			"close": "Fermer",
			"ok": "Ok",
			"filters": {
				"searchLabel": "Filtre",
				"searchPlaceholder": "Filtrer par médicament, motif ou vétérinaire",
				"statusLabel": "Statut",
				"statusPlaceholder": "Statut",
				"statusClearAria": "Effacer le statut"
			},
			"status": {
				"active": "Actif",
				"paused": "En pause",
				"finished": "Terminé",
				"draft": "Brouillon",
				"cancelled": "Annulé"
			},
			"schedule": {
				"daily": "Quotidien",
				"dailyTimes": "{count}x par jour",
				"weekly": "Hebdomadaire",
				"monthly": "Mensuel"
			},
			"form": {
				"tabsAria": "Traitement",
				"tabs": {
					"general": "Général",
					"frequency": "Fréquence et horaires",
					"dose": "Dose",
					"package": "Emballage et stock",
					"notes": "Notes",
					"plan": "Plan",
					"items": "Éléments",
					"validity": "Validité"
				},
				"fields": {
					"medName": "Médicament",
					"medPresentation": "Présentation",
					"medManufacturer": "Fabricant",
					"conditions": "Conditions cliniques",
					"startedAt": "Début",
					"durationMode": "Durée",
					"durationDays": "En jours",
					"untilDate": "Date de fin",
					"vetName": "Vétérinaire",
					"reason": "Motif",
					"frequencyMode": "Fréquence",
					"times": "Horaires",
					"time": "Horaire",
					"weeklyWeekdays": "Jours de la semaine",
					"monthlyMonthdays": "Jours du mois",
					"doseValue": "Dose",
					"doseUnit": "Unité",
					"doseRoute": "Voie",
					"insulinKind": "Type d'insuline",
					"insulinConcentration": "Concentration",
					"insulinDelivery": "Présentation",
					"openedAt": "Ouvert le",
					"openedValidDays": "Dure après ouverture (jours)",
					"discardAt": "Jeter le",
					"expiresAt": "Expiration",
					"amountTotal": "Quantité totale",
					"amountUnit": "Unité",
					"amountRemaining": "Restant",
					"lowStockThreshold": "Alerte stock bas",
					"noteText": "Ajouter une note",
					"planName": "Nom du plan",
					"generalInstructions": "Instructions générales",
					"itemName": "Nom de l'élément",
					"details": "Détails",
					"estimatedEndDate": "Fin estimée",
					"visit": "Consultation",
					"veterinarian": "Vétérinaire",
					"vetOther": "Autre",
					"vetCrmv": "CRMV",
					"hasPause": "Intervalle du traitement",
					"pauseDays": "Jours de pause",
					"durationAgain": "Durée à nouveau (jours)",
					"isInsulin": "Insuline"
				},
				"placeholders": {
					"conditions": "Sélectionnez une ou plusieurs conditions",
					"select": "Sélectionnez",
					"doseUnit": "ex. : UI, mg, ml",
					"doseRoute": "ex. : oral, SC",
					"amountUnit": "ex. : ml, comprimés",
					"visit": "Lier à une consultation"
				},
				"linkedPreventivesTitle": "Préventifs liés",
				"hints": {
					"noConditions": "Aucune condition enregistrée pour le moment.",
					"noteSaveWithTreatment": "Cette note sera enregistrée avec le traitement lorsque vous cliquerez sur « Enregistrer ».",
					"visitLocked": "Consultation définie par l’ordonnance et non modifiable."
				},
				"actions": {
					"removeTime": "Supprimer",
					"addTime": "Ajouter un horaire",
					"saveNote": "Enregistrer la note",
					"addItem": "Ajouter un élément",
					"removeItem": "Supprimer l'élément",
					"registerPreventive": "Enregistrer comme préventif"
				},
				"duration": {
					"indefinite": "Indéfini",
					"continuous": "Continu",
					"for_days": "Pendant des jours",
					"until_date": "Jusqu'à une date"
				},
				"frequency": {
					"daily": "Quotidien",
					"weekly": "Hebdomadaire",
					"monthly": "Mensuel"
				},
				"weekdays": {
					"0": "Dim",
					"1": "Lun",
					"2": "Mar",
					"3": "Mer",
					"4": "Jeu",
					"5": "Ven",
					"6": "Sam"
				},
				"insulin": {
					"kind": {
						"glargine": "Glargine",
						"pzi": "PZI / ProZinc",
						"lente": "Lente (Vetsulin)",
						"nph": "NPH",
						"detemir": "Detemir",
						"other": "Autre"
					},
					"concentration": {
						"U40": "U-40",
						"U100": "U-100",
						"other": "Autre"
					},
					"delivery": {
						"vial": "Flacon",
						"pen": "Stylo",
						"cartridge": "Cartouche"
					}
				},
				"errors": {
					"scheduleRequired": "Renseignez la fréquence et au moins un horaire.",
					"durationDaysRequired": "Indiquez le nombre de jours.",
					"untilDateRequired": "Indiquez la date de fin.",
					"vetRequired": "Indiquez le nom et le CRMV du vétérinaire."
				},
				"successSave": "Traitement enregistré avec succès.",
				"successEdit": "Traitement mis à jour avec succès.",
				"errorSave": "Impossible d'enregistrer le traitement.",
				"planSection": "Détails du plan",
				"itemsSection": "Éléments du plan",
				"itemsTabAria": "Éléments du traitement",
				"itemLabel": "Élément {number}",
				"outerTabsAria": "Sections du plan de traitement"
			},
			"validity": {
				"opened": "Ouvert",
				"discard": "Jeter"
			},
			"columns": {
				"startedAt": "Début",
				"medication": "Médicament",
				"dose": "Dose",
				"schedule": "Fréquence",
				"validity": "Validité après ouverture",
				"status": "Statut",
				"actions": "Actions",
				"items": "Éléments",
				"vet": "Vétérinaire"
			},
			"empty": {
				"title": "Aucun traitement enregistré",
				"description": "Ajoutez un traitement et suivez les doses et la validité."
			},
			"noResults": {
				"title": "Aucun traitement trouvé",
				"description": "Essayez d'ajuster les filtres pour trouver ce que vous cherchez."
			},
			"actions": {
				"editAria": "Modifier le traitement",
				"pauseAria": "Mettre le traitement en pause",
				"reactivateAria": "Réactiver le traitement",
				"finishAria": "Terminer le traitement",
				"deleteAria": "Supprimer le traitement",
				"viewAria": "Voir le traitement"
			},
			"pause": {
				"success": "Traitement mis en pause."
			},
			"reactivate": {
				"success": "Traitement réactivé."
			},
			"finish": {
				"title": "Terminer le traitement ?",
				"contentWithName": "Voulez-vous vraiment terminer \"{name}\" ?",
				"contentGeneric": "Voulez-vous vraiment terminer ce traitement ?",
				"confirm": "Terminer",
				"cancel": "Annuler",
				"success": "Traitement terminé."
			},
			"delete": {
				"title": "Supprimer le traitement ?",
				"contentWithName": "Voulez-vous vraiment supprimer \"{name}\" ? Cette action est irréversible.",
				"contentGeneric": "Voulez-vous vraiment supprimer ce traitement ? Cette action est irréversible.",
				"confirm": "Supprimer",
				"cancel": "Annuler",
				"success": "Traitement supprimé."
			},
			"errors": {
				"load": "Impossible de charger les traitements.",
				"status": "Impossible de mettre à jour le statut du traitement.",
				"delete": "Impossible de supprimer le traitement."
			}
		},
		"consultations": {
			"loading": "Chargement des consultations",
			"close": "Fermer",
			"ok": "Ok",
			"filters": {
				"visitedFromLabel": "Date consultation (du)",
				"visitedToLabel": "Date consultation (au)",
				"nextVisitFromLabel": "Date suivi (du)",
				"nextVisitToLabel": "Date suivi (au)",
				"kindLabel": "Type de consultation",
				"kindPlaceholder": "Type",
				"kindClearAria": "Effacer le type de consultation",
				"modeLabel": "Mode de consultation",
				"modePlaceholder": "Mode",
				"modeClearAria": "Effacer le mode de consultation",
				"vetLabel": "Vétérinaire",
				"vetPlaceholder": "Nom ou CRMV",
				"clinicLabel": "Clinique",
				"clinicPlaceholder": "Filtrer par clinique"
			},
			"kinds": {
				"routine": "Routine",
				"emergency": "Urgence",
				"follow_up": "Suivi",
				"return": "Suivi",
				"urgent": "Urgence",
				"monitoring": "Surveillance",
				"preoperative": "Préopératoire",
				"postoperative": "Postopératoire",
				"vaccination": "Vaccination",
				"exam": "Évaluation d'examen",
				"other": "Autre"
			},
			"modes": {
				"home": "Domicile",
				"clinic": "Clinique",
				"telehealth": "Téléconsultation",
				"campaign": "Campagne",
				"shelter": "Refuge",
				"other": "Autre"
			},
			"columns": {
				"visitedAt": "Date consultation",
				"nextVisitAt": "Date de suivi",
				"kind": "Type",
				"mode": "Mode",
				"vet": "Vétérinaire",
				"clinic": "Clinique",
				"links": "Liens",
				"notes": "Notes",
				"actions": "Actions"
			},
			"links": {
				"separator": " · ",
				"vaccine": "{count} vaccin",
				"vaccines": "{count} vaccins",
				"exam": "{count} examen",
				"exams": "{count} examens",
				"condition": "{count} condition",
				"conditions": "{count} conditions"
			},
			"empty": {
				"title": "Aucune consultation enregistrée",
				"description": "Et si vous planifiez un check-up pour votre animal ?"
			},
			"noResults": {
				"title": "Aucune consultation trouvée",
				"description": "Essayez d'ajuster les filtres pour trouver ce que vous cherchez."
			},
			"actions": {
				"editAria": "Modifier la consultation",
				"deleteAria": "Supprimer la consultation"
			},
			"delete": {
				"title": "Supprimer la consultation ?",
				"contentGeneric": "Cette action ne pourra pas être annulée.",
				"confirm": "Supprimer",
				"cancel": "Annuler",
				"success": "Consultation supprimée."
			},
			"errors": {
				"load": "Impossible de charger les consultations.",
				"delete": "Impossible de supprimer la consultation."
			},
			"form": {
				"tabsAria": "Onglets du formulaire de consultation",
				"tabs": {
					"general": "Informations générales",
					"vaccines": "Vaccin",
					"exams": "Examens",
					"diagnosis": "Diagnostic et conduites",
					"finance": "Financier",
					"history": "Anamnèse et examen physique",
					"conduct": "Conduites réalisées",
					"prescription": "Prescription et consignes",
					"documents": "Documents"
				},
				"visitedAtDate": "Date de la visite",
				"visitedAtTime": "Heure",
				"visitType": "Type",
				"visitMode": "Mode",
				"clinic": "Clinique",
				"clinicPlaceholder": "Rechercher une clinique ou un lieu",
				"clinicOther": "Autre",
				"clinicName": "Nom de la clinique / du lieu",
				"clinicNamePlaceholder": "Ex. : Clinique X",
				"veterinarian": "Vétérinaire",
				"vetPlaceholder": "Rechercher par nom ou CRMV",
				"vetOther": "Autre",
				"vetName": "Nom du vétérinaire",
				"vetNamePlaceholder": "Nom complet",
				"vetCrmv": "CRMV",
				"vetCrmvPlaceholder": "Ex. : CRMV-SP 12345",
				"nextVisitAt": "Date de suivi",
				"reason": "Motif de la consultation",
				"reasonPlaceholder": "Ex. : vomissements, bilan, suivi",
				"notes": "Notes de la consultation",
				"weightKg": "Poids (kg)",
				"tempC": "Température (°C)",
				"tempLo": "LOW/LO (sans température)",
				"tempLoTooltip": "Cochez lorsque le thermomètre n'a pas pu mesurer la température (valeur sous l'échelle ou lecture invalide). La température ne sera pas enregistrée.",
				"relatedVisit": "Consultation d'origine",
				"relatedVisitPlaceholder": "Sélectionnez la consultation précédente",
				"heartRateBpm": "Fréquence cardiaque (bpm)",
				"respRateBpm": "Fréquence respiratoire",
				"capillaryRefillSec": "Temps de recoloration (s)",
				"examSummary": "Résumé de l'examen",
				"findings": "Constatations de l'examen physique",
				"examRequests": "Examens demandés",
				"examRequestsPlaceholder": "Sélectionner panneaux et examens",
				"examPanelPrefix": "Panneau :",
				"otherExamTitle": "Autre examen (hors catalogue)",
				"otherExamHint": "À utiliser lorsque l’examen demandé n’est pas dans le catalogue.",
				"otherExamName": "Nom de l’examen",
				"otherExamNamePlaceholder": "Ex. : Bilan hépatique complet",
				"otherExamNameRequired": "Saisissez le nom de l’examen pour l’ajouter.",
				"otherExamKind": "Type (optionnel)",
				"otherExamKindNone": "Non renseigné",
				"otherExamKindPlaceholder": "Sélectionner le type",
				"otherExamNotes": "Note (optionnel)",
				"otherExamNotesPlaceholder": "Détails de la demande",
				"otherExamAdd": "Ajouter un autre examen",
				"freeExamTitle": "Titre libre / demande documentaire",
				"freeExamTitlePlaceholder": "Ex. : Demande d’examens de la clinique X",
				"documentOnlyRequest": "Demande documentaire seule (sans items structurés)",
				"diagnosis": "Diagnostic",
				"conditionOr": "OU",
				"conditionLink": "Lier une condition existante",
				"conditionLinkPlaceholder": "Rechercher les conditions de l'animal",
				"conditionDiagnosisNote": "Diagnostic (note)",
				"conditionDiagnosisNotePlaceholder": "Décrire le diagnostic clinique",
				"conditionNameRequired": "Saisissez le nom de la condition ou liez une existante pour enregistrer les données de condition clinique.",
				"proceduresDone": "Procédures réalisées",
				"medsAdministered": "Médicaments administrés",
				"costTotal": "Coût total",
				"paidTotal": "Montant payé",
				"paymentMethod": "Mode de paiement",
				"successSave": "Consultation enregistrée avec succès.",
				"successEdit": "Consultation mise à jour avec succès.",
				"errorSave": "Impossible d'enregistrer la consultation.",
				"returnReason": "Objectif du suivi",
				"systolicBloodPressure": "Pression artérielle systolique (mmHg)",
				"mucousMembrane": "Muqueuses",
				"hydrationStatus": "Hydratation",
				"bodyConditionScore": "Score corporel",
				"bodyConditionScale": "Échelle du score corporel",
				"historyText": "Historique rapporté par le tuteur",
				"reportedSigns": "Signes perçus par le tuteur",
				"painReported": "Le tuteur a-t-il perçu de la douleur ?",
				"painDetails": "Détails de la douleur rapportée",
				"generalConduct": "Conduite générale réalisée pendant la consultation",
				"diagnosisName": "Hypothèse ou diagnostic",
				"diagnosisStatus": "Statut",
				"diagnosisNotes": "Observations",
				"newConditionName": "Créer une condition nommée",
				"addDiagnosis": "Ajouter une hypothèse ou un diagnostic",
				"prescriptionOriginal": "Texte original de la prescription",
				"prescriptionSource": "Origine de la prescription",
				"prescriptionGeneralInstructions": "Consignes générales",
				"prescriptionItemType": "Type de consigne",
				"prescriptionItemName": "Nom",
				"doseText": "Dose",
				"frequencyText": "Fréquence",
				"durationText": "Durée",
				"route": "Voie",
				"prescriptionItemInstructions": "Instructions",
				"addPrescriptionItem": "Ajouter un élément à la prescription",
				"createTreatmentFromPrescription": "Créer un traitement à partir de la prescription",
				"treatmentFromPrescriptionSuccess": "Plan de traitement créé à partir de la prescription.",
				"treatmentFromPrescriptionError": "Impossible de créer le traitement à partir de la prescription.",
				"prescriptionUpload": "Pièces jointes à l'ordonnance",
				"diagnosisUpload": "Rapports et documents de ce diagnostic",
				"examUpload": "Pièces jointes à la demande d'examens",
				"financeUpload": "Reçus et factures",
				"uploadDropzone": "Glissez les fichiers ici ou sélectionnez-les sur votre appareil",
				"uploadBrowse": "Sélectionner des fichiers",
				"uploadConstraints": "PDF, JPG, PNG ou WEBP jusqu'à 10 Mo par fichier",
				"uploadAddMore": "Ajouter d'autres fichiers",
				"uploadInvalidType": "Ce type de fichier n'est pas autorisé.",
				"uploadTooLarge": "Le fichier dépasse la limite de __MAX_SIZE__.",
				"uploadDocument": "Envoyer un document (PDF ou image)",
				"documentsEmpty": "Aucun document joint à cette consultation.",
				"documentUploadSuccess": "Document envoyé.",
				"documentUploadError": "Impossible d'envoyer le document.",
				"documentDeleteError": "Impossible de supprimer le document.",
				"documentOpenError": "Impossible d'ouvrir le document.",
				"weightReplaceTitle": "Un poids différent est déjà enregistré ce jour-là",
				"weightReplaceDescription": "Un poids de {existing} kg existe déjà pour ce jour, et la consultation indique {next} kg. Que souhaitez-vous faire ?",
				"weightReplaceConfirm": "Utiliser le poids de la consultation",
				"weightReplaceSkip": "Conserver le poids déjà enregistré",
				"documentViewImage": "Voir l'image",
				"documentOpenFile": "Ouvrir le fichier",
				"documentDeleteSuccess": "Document supprimé.",
				"documentZoomIn": "Zoom avant",
				"documentZoomOut": "Zoom arrière",
				"documentZoomReset": "{zoom}%",
				"financeDocumentDescription": "Justificatif financier",
				"weightDuplicateDay": "Un poids est déjà enregistré ce jour-là",
				"documentsPrescriptionLabel": "Ordonnances",
				"documentsFinanceLabel": "Justificatifs financiers",
				"documentsExamLabel": "Pièces jointes d’examens",
				"documentsDiagnosisLabel": "Documents du diagnostic",
				"documentDownloadError": "Impossible de télécharger le document."
			},
			"pain": {
				"yes": "Oui",
				"no": "Non",
				"unknown": "Ne sait pas"
			},
			"diagnosisStatus": {
				"suspected": "Suspicion",
				"under_investigation": "En investigation",
				"probable": "Probable",
				"confirmed": "Confirmé",
				"ruled_out": "Écarté",
				"known_condition": "Condition déjà connue",
				"other": "Autre"
			},
			"prescriptionTypes": {
				"medication": "Médicament",
				"fluid_therapy": "Fluidothérapie",
				"physiotherapy": "Physiothérapie",
				"supplement": "Complément",
				"diet": "Régime",
				"home_care": "Soins à domicile",
				"monitoring": "Surveillance",
				"restriction": "Restriction",
				"follow_up": "Suivi",
				"other": "Autre"
			},
			"prescriptionSources": {
				"written": "Ordonnance écrite",
				"verbal": "Consignes verbales",
				"attachment": "Pièce jointe",
				"clinic_report": "Rapport de clinique",
				"tutor_notes": "Note du tuteur",
				"other": "Autre"
			},
			"reportedSigns": {
				"apathy": "Apathie",
				"perceived_fever": "Fièvre perçue",
				"vomiting": "Vomissement",
				"diarrhea": "Diarrhée",
				"itching": "Démangeaison",
				"loss_of_appetite": "Perte d'appétit",
				"increased_appetite": "Augmentation de l'appétit",
				"increased_thirst": "Augmentation de la soif",
				"increased_urination": "Augmentation des urines",
				"difficulty_urinating": "Difficulté à uriner",
				"cough": "Toux",
				"difficulty_breathing": "Difficulté à respirer",
				"difficulty_walking": "Difficulté à marcher",
				"discharge": "Sécrétion",
				"bleeding": "Saignement",
				"behavior_change": "Changement de comportement",
				"pain": "Douleur",
				"other": "Autre"
			}
		},
		"glycemia": {
			"loading": "Chargement des courbes glycémiques",
			"tabsAria": "Onglets de glycémie",
			"tabs": {
				"daily": "Quotidienne",
				"curve": "Courbe",
				"compare": "Comparaison"
			},
			"close": "Fermer",
			"ok": "Ok",
			"columns": {
				"date": "Date",
				"startTime": "Début",
				"clicks": "Dose (UI)",
				"dose": "Dose (UI)",
				"pointsRecorded": "Points",
				"notes": "Notes",
				"actions": "Actions"
			},
			"pointsRecordedValue": "{count}/5",
			"doseUnit": "UI",
			"now": "maintenant",
			"pointGlucosePlaceholder": "ex. : 122 ou HI",
			"form": {
				"date": "Date",
				"startTime": "Heure de début",
				"warnMinutes": "Alerte (min avant)",
				"warnMinutesTooltip": "Ce délai est réservé aux notifications Web Push. Dans la vue d'ensemble, les mesures proches apparaissent dans « Bientôt » avec une règle fixe d'1 heure.",
				"warnMinutesReadonly": "Alerte Web Push (min avant)",
				"doseUi": "Dose d'insuline (UI)",
				"autoScheduleHint": "Points automatiques toutes les 3h : {t1}, {t2}, {t3}, {t4}, {t5}",
				"sessionCreateSuccess": "Courbe glycémique enregistrée avec succès.",
				"sessionErrorSave": "Impossible d'enregistrer la courbe glycémique."
			},
			"empty": {
				"title": "Aucune courbe glycémique enregistrée",
				"description": "Enregistrez une courbe pour suivre la réponse à la dose."
			},
			"actions": {
				"openAria": "Ouvrir la mesure",
				"deleteAria": "Supprimer la mesure"
			},
			"delete": {
				"title": "Supprimer la mesure ?",
				"contentWithDate": "Supprimer définitivement la mesure du {date} avec toutes les valeurs ?",
				"contentGeneric": "Supprimer définitivement cette mesure avec toutes les valeurs ?",
				"confirm": "Supprimer",
				"cancel": "Annuler",
				"success": "Mesure supprimée avec succès."
			},
			"errors": {
				"load": "Impossible de charger les courbes glycémiques.",
				"delete": "Impossible de supprimer la mesure.",
				"pointGlucoseAndTimeRequired": "Indiquez la glycémie et l'heure pour enregistrer le point.",
				"pointSave": "Impossible d'enregistrer le point de la courbe.",
				"glucoseConflictTitle": "Glycémie différente au même horaire",
				"glucoseConflictDescription": "Il existe déjà une lecture quotidienne de {existing} à cette heure. La courbe indique {next}. Que souhaitez-vous faire ?",
				"glucoseConflictConfirm": "Utiliser la valeur de la courbe",
				"glucoseConflictKeep": "Conserver la valeur quotidienne"
			},
			"daily": {
				"loading": "Chargement de la glycémie quotidienne",
				"type": "Lecture",
				"newTitle": "Nouvelle lecture quotidienne",
				"newSubtitle": "Enregistrez la glycémie du quotidien",
				"editTitle": "Modifier la lecture quotidienne",
				"editSubtitle": "Mettre à jour glycémie, heure et insuline",
				"dateLockedHint": "La date ne peut pas être modifiée. Ajustez uniquement l'heure, la glycémie et l'insuline.",
				"createSuccess": "Lecture enregistrée avec succès.",
				"updateSuccess": "Lecture mise à jour avec succès.",
				"chartName": "Glycémie",
				"chartRange": {
					"label": "Période du graphique",
					"d7": "7 jours",
					"d15": "15 jours",
					"d30": "30 jours",
					"custom": "Personnalisé",
					"from": "Du",
					"to": "Au",
					"apply": "Appliquer",
					"panelTitle": "Graphique de la période",
					"min": "Valeur la plus basse : {value} mg/dL",
					"max": "Valeur la plus haute : {value} mg/dL",
					"minPrefix": "Valeur la plus basse",
					"maxPrefix": "Valeur la plus haute",
					"lowestPeriod": "Période la plus basse : {period}",
					"highestPeriod": "Période la plus haute : {period}",
					"lowestPeriodPrefix": "Période la plus basse",
					"highestPeriodPrefix": "Période la plus haute",
					"periodDawn": "Nuit (00h–06h)",
					"periodMorning": "Matin (06h–12h)",
					"periodAfternoon": "Après-midi (12h–18h)",
					"periodNight": "Soirée (18h–00h)",
					"periodUnknown": "Données insuffisantes",
					"measurementsCountLabel": "Mesures sur la période",
					"measurementsCount": "Mesures sur la période : {count}",
					"insulinAppliedLabel": "Insulines appliquées",
					"rangeTooLong": "La période personnalisée peut couvrir au maximum 6 mois. Choisissez un intervalle plus court.",
					"loLegend": "LO (< 20/10 mg/dL)",
					"hiLegend": "HI (> 500/600 mg/dL)",
					"loCountLabel": "Mesures LO",
					"hiCountLabel": "Mesures HI",
					"flagsNote": "Aussi sur la période : {flags}",
					"generatePdf": "Générer le PDF",
					"pdfTitle": "Glycémie quotidienne",
					"pdfPeriod": "Période : {from} à {to}",
					"pdfFileName": "glycemie-quotidienne-{from}_{to}.pdf",
					"pdfError": "Impossible de générer le PDF.",
					"pdfColumns": {
						"date": "Date",
						"time": "Heure",
						"glucose": "mg/dL",
						"insulin": "Dose d’insuline",
						"notes": "Observations"
					}
				},
				"hiLabel": "HI (au-dessus de la limite du lecteur)",
				"loLabel": "LO (en dessous de la limite du lecteur)",
				"glucoseMode": {
					"value": "Valeur",
					"lo": "LO",
					"hi": "HI"
				},
				"columns": {
					"time": "Heure",
					"glucose": "mg/dL",
					"insulin": "Insuline"
				},
				"insulin": {
					"yes": "Administrée",
					"no": "Non administrée",
					"notRegistered": "Non enregistrée",
					"notAdministered": "Je n'ai pas administré d'insuline",
					"notAdministeredHint": "Cochez si vous avez choisi de ne pas administrer. Laisser la dose vide sans cocher signifie que la dose n'a pas été enregistrée."
				},
				"empty": {
					"title": "Aucune lecture quotidienne",
					"description": "Enregistrez la glycémie au quotidien pour suivre le contrôle."
				},
				"actions": {
					"deleteAria": "Supprimer la lecture",
					"editAria": "Modifier la lecture",
					"deleteLockedTooltip": "Les enregistrements de la courbe glycémique ne peuvent être supprimés que par un administrateur"
				},
				"delete": {
					"title": "Supprimer la lecture ?",
					"content": "Supprimer définitivement cette lecture quotidienne ?",
					"success": "Lecture supprimée avec succès."
				},
				"errors": {
					"load": "Impossible de charger la glycémie quotidienne.",
					"loadOne": "Impossible de charger la lecture.",
					"save": "Impossible d'enregistrer la lecture.",
					"delete": "Impossible de supprimer la lecture.",
					"glucoseRequired": "Indiquez la glycémie ou cochez LO ou HI.",
					"duplicateDateTime": "Une lecture existe déjà à cette date et heure.",
					"duplicateSameValue": "Une lecture avec la même valeur existe déjà à cette date et heure.",
					"glucoseConflictTitle": "Glycémie différente au même horaire",
					"glucoseConflictDescription": "Il existe déjà une lecture de {existing} à cette heure. La nouvelle valeur est {next}. Que souhaitez-vous faire ?",
					"glucoseConflictConfirm": "Utiliser la nouvelle valeur",
					"glucoseConflictKeep": "Conserver la valeur existante"
				}
			},
			"compare": {
				"insufficientTitle": "Mesures insuffisantes",
				"insufficientDescription": "Il faut au moins 2 courbes glycémiques enregistrées pour comparer.",
				"measurementA": "Mesure A",
				"measurementB": "Mesure B",
				"measurementC": "Mesure C",
				"select": "Sélectionner",
				"selectOptional": "Sélectionnez",
				"threshold": "Seuil de différence",
				"run": "Comparer",
				"note": "Note",
				"formPanelTitle": "Sélectionner les mesures",
				"seriesNamed": "{label} ({date})",
				"hiDisplay": "HI (600+)",
				"notes": {
					"lower": "plus bas",
					"higher": "plus haut",
					"equal": "égal",
					"atLeast": "Au moins {delta}"
				}
			}
		},
		"conditions": {
			"loading": "Chargement des conditions cliniques",
			"close": "Fermer",
			"ok": "Ok",
			"columns": {
				"name": "Nom",
				"curability": "Guérison",
				"status": "Statut",
				"severity": "Sévérité",
				"diagnosedAt": "Diagnostiqué le",
				"actions": "Actions"
			},
			"curability": {
				"CURÁVEL": "Guérissable",
				"NÃO_CURÁVEL": "Non guérissable",
				"INDEFINIDO": "En évaluation"
			},
			"status": {
				"ATIVA": "Active",
				"RESOLVIDA": "Résolue",
				"EM_MANEJO": "En traitement",
				"DESCARTADA": "Écartée"
			},
			"severity": {
				"BAIXA": "Faible",
				"MODERADA": "Modérée",
				"ALTA": "Élevée"
			},
			"conditionType": {
				"AGUDA": "Aiguë",
				"CRÔNICA": "Chronique",
				"CONGÊNITA": "Congénitale",
				"RECORRENTE": "Récurrente",
				"DESCONHECIDA": "Inconnue"
			},
			"bodySystem": {
				"ENDÓCRINO": "Endocrinien",
				"RENAL": "Rénal",
				"CARDÍACO": "Cardiaque",
				"RESPIRATÓRIO": "Respiratoire",
				"GASTROINTESTINAL": "Gastro-intestinal",
				"NEUROLÓGICO": "Neurologique",
				"OSTEOARTICULAR": "Ostéoarticulaire",
				"DERMATOLÓGICO": "Dermatologique",
				"HEMATOLÓGICO": "Hématologique",
				"OFTÁLMICO": "Ophtalmique",
				"OUTRO": "Autre"
			},
			"controlStatus": {
				"BEM_CONTROLADA": "Bien contrôlée",
				"PARCIALMENTE_CONTROLADA": "Partiellement contrôlée",
				"DESCOMPENSADA": "Décompensée"
			},
			"lifeRisk": {
				"BAIXO": "Faible",
				"MODERADO": "Modéré",
				"ALTO": "Élevé",
				"EMERGENCIAL": "Urgence"
			},
			"form": {
				"name": "Nom de la condition",
				"curability": "Curabilité",
				"status": "Statut",
				"severity": "Sévérité",
				"conditionType": "Type de condition",
				"bodySystem": "Système / organe principal",
				"controlStatus": "Situation de contrôle",
				"lifeRisk": "Risque vital associé",
				"symptomStartAt": "Début des symptômes",
				"diagnosedAt": "Diagnostiqué le",
				"resolvedAt": "Résolue le",
				"notes": "Note initiale",
				"followupPlan": "Plan de suivi",
				"successSave": "Condition enregistrée avec succès.",
				"successEdit": "Condition mise à jour avec succès.",
				"errorSave": "Impossible d'enregistrer la condition."
			},
			"details": {
				"tabs": {
					"aria": "Onglets de la condition clinique",
					"general": "Informations générales",
					"notes": "Notes",
					"links": "Liens"
				},
				"infoTitle": "Informations",
				"notesTitle": "Notes",
				"linksTitle": "Liens",
				"noteFormTitle": "Enregistrer une note",
				"noteFormEditTitle": "Modifier la note",
				"noteContent": "Note",
				"notePlaceholder": "Écrire une note",
				"recordedAt": "Enregistré le",
				"addNote": "Ajouter une note",
				"sortLabel": "Tri",
				"sortDesc": "Plus récentes d'abord",
				"sortAsc": "Plus anciennes d'abord",
				"notesEmpty": "Aucune note",
				"notesEmptyTitle": "Aucune note",
				"notesEmptyDescription": "Ajoutez la première note pour suivre l'évolution de cette condition.",
				"columns": {
					"recordedAt": "Date",
					"content": "Note",
					"status": "Statut",
					"severity": "Gravité",
					"actions": "Actions"
				},
				"labResults": "Résultats d'examen",
				"labResultPlaceholder": "Sélectionner un résultat",
				"treatments": "Traitements",
				"treatmentPlaceholder": "Sélectionner un traitement",
				"link": "Lier",
				"deleteNoteTitle": "Supprimer la note ?",
				"deleteNoteWithPreview": "Cette action est irréversible. Note : \"{preview}\"",
				"deleteNoteGeneric": "Cette action est irréversible.",
				"historyNotePrefix": "Mise à jour clinique : {changes}",
				"historyChange": "{field} : {from} → {to}",
				"historyEmpty": "non renseigné",
				"saveSuccess": "Condition mise à jour avec succès.",
				"saveError": "Impossible de mettre à jour la condition."
			},
			"empty": {
				"title": "Aucune condition trouvée",
				"description": "C'est l'endroit idéal pour suivre les besoins de votre animal !"
			},
			"actions": {
				"openAria": "Ouvrir la condition",
				"deleteAria": "Supprimer la condition"
			},
			"delete": {
				"title": "Supprimer la condition clinique ?",
				"contentWithName": "Cette action est irréversible. Condition : \"{name}\"",
				"contentGeneric": "Cette action est irréversible.",
				"confirm": "Supprimer",
				"cancel": "Annuler",
				"success": "Condition supprimée avec succès."
			},
			"errors": {
				"load": "Impossible de charger les conditions cliniques.",
				"delete": "Impossible de supprimer la condition."
			}
		},
		"exams": {
			"loading": "Chargement des examens",
			"close": "Fermer",
			"columns": {
				"requestedAt": "Demandé le",
				"tests": "Examens demandés",
				"clinic": "Clinique",
				"vet": "Vétérinaire",
				"status": "Statut",
				"progress": "Progression",
				"actions": "Actions"
			},
			"status": {
				"MISSING": "En attente",
				"PENDING": "En attente",
				"PARTIAL": "Partiel",
				"DONE": "Terminé",
				"DOCUMENT": "Fichier seul"
			},
			"empty": {
				"title": "Aucun examen trouvé",
				"description": "Et si vous mettiez les examens de votre animal à jour ?"
			},
			"actions": {
				"openAria": "Ouvrir l'examen",
				"deleteAria": "Supprimer le résultat",
				"deleteDisabledTooltip": "Les résultats liés à une consultation ne peuvent être modifiés ou supprimés que dans la consultation."
			},
			"origin": {
				"manual": "Manuel",
				"visit": "Consultation"
			},
			"testsMore": "+ {count} examens",
			"testsMoreSingular": "+ {count} examen",
			"delete": {
				"title": "Supprimer le résultat d’analyse ?",
				"content": "Cette action est irréversible.",
				"confirm": "Supprimer",
				"cancel": "Annuler",
				"success": "Résultat supprimé.",
				"error": "Impossible de supprimer le résultat."
			},
			"fallback": {
				"exam": "Examen",
				"panel": "Pack",
				"exams": "Examens",
				"request": "Demande",
				"noRef": "Sans référence",
				"noValue": "Sans valeur",
				"inRange": "Dans la plage",
				"low": "Bas",
				"high": "Haut",
				"noRefShort": "Sans réf.",
				"improving": "En amélioration",
				"worsening": "En aggravation",
				"stable": "Stable",
				"noBaseline": "Sans base"
			},
			"referenceDisclaimer": "Les valeurs de référence sont informatives et ne remplacent pas l'évaluation clinique ni ne diagnostiquent à elles seules.",
			"compare": {
				"filters": {
					"examLabel": "Examen / panel",
					"examPlaceholder": "Rechercher un examen ou un panel",
					"panelLabel": "Panel",
					"panelPlaceholder": "Filtrer par panel",
					"fromLabel": "Du",
					"toLabel": "Au",
					"clear": "Effacer",
					"rangeLabel": "Plage de référence",
					"rangePlaceholder": "Toutes les plages",
					"rangeIn": "Dans la plage",
					"rangeOut": "Hors plage (haut ou bas)",
					"rangeLow": "Sous la plage",
					"rangeHigh": "Au-dessus de la plage",
					"onlyRepeated": "Uniquement les examens avec plus d’une occurrence"
				},
				"metrics": {
					"exams": "examens",
					"out": "hors",
					"inRange": "dans la plage",
					"last": "dernier",
					"missingPartial": "{count} examens sans enregistrement complet",
					"neverRecorded": "{count} examens sans aucun enregistrement"
				},
				"empty": {
					"title": "Aucun examen réalisé",
					"description": "Vous verrez ici la comparaison des valeurs des examens pour suivre l'évolution de votre animal !"
				},
				"card": {
					"ref": "Réf. :",
					"lastValue": "Dernière valeur",
					"chartAria": "Évolution de l'examen",
					"noChartData": "Pas de données numériques pour un graphique.",
					"date": "Date",
					"value": "Valeur",
					"panel": "Panel"
				},
				"errors": {
					"load": "Impossible de charger le comparatif."
				}
			},
			"details": {
				"tabs": {
					"aria": "Sections du résultat d'examen",
					"info": "Demande",
					"values": "Valeurs",
					"documents": "Comptes rendus"
				},
				"meta": {
					"saveError": "Impossible d'enregistrer les informations de la demande."
				},
				"visit": {
					"consultation": "Date de demande",
					"clinic": "Clinique",
					"vet": "Vétérinaire"
				},
				"itemsCount": "éléments",
				"columns": {
					"exam": "Examen",
					"reference": "Référence",
					"value": "Valeur",
					"performed": "Réalisé",
					"resulted": "Résultat",
					"actions": "Actions"
				},
				"edit": {
					"numeric": "Numérique",
					"text": "Texte",
					"refLow": "Min.",
					"refHigh": "Max.",
					"refText": "Réf. (texte)",
					"reportText": "Compte rendu / description",
					"conclusion": "Conclusion",
					"reportShort": "Compte rendu",
					"notPerformed": "Non réalisé",
					"valueNumPlaceholder": "Saisir la valeur",
					"valueTextPlaceholder": "Saisir le résultat",
					"resetReference": "Réinitialiser la référence"
				},
				"status": {
					"label": "Statut",
					"PENDING": "En attente",
					"PARTIAL": "Partiel",
					"DONE": "Terminé"
				},
				"panelReport": {
					"title": "Compte rendu du panel"
				},
				"requestReport": {
					"title": "Compte rendu / résultat de la demande"
				},
				"availability": {
					"NO_RESULT": "Sans résultat",
					"DOCUMENT_ONLY": "Documentaire seul",
					"STRUCTURED": "Structuré",
					"HYBRID": "Hybride"
				},
				"documentOnlyEmpty": "Résultat joint — pas de données structurées pour la comparaison.",
				"noStructuredItems": "Aucun examen structuré dans cette demande.",
				"documents": {
					"title": "Fichiers joints",
					"upload": "Joindre le compte rendu (PDF ou image)",
					"extractPdf": "Extraire du PDF",
					"empty": "Aucun fichier joint à ce résultat.",
					"openError": "Impossible d'ouvrir le fichier.",
					"itemTitle": "Compte rendu de l'item",
					"uploadHint": "Envoyez un PDF ou une image. Si l’OCR reconnaît le texte, nous suggérons des items structurés ; sinon le fichier est enregistré au compte rendu."
				},
				"ocr": {
					"title": "Revue de l'extraction",
					"hint": "Confirmez, modifiez ou ignorez chaque ligne avant d'appliquer à la demande.",
					"empty": "Aucune ligne d'examen trouvée dans le PDF (peut ne pas avoir de couche texte).",
					"warning": "Extraction avec avertissements : {message}",
					"failed": "Échec de l'extraction : {message}",
					"suggested": "Suggestion",
					"value": "Valeur",
					"unit": "Unité",
					"confirm": "Confirmer",
					"ignore": "Ignorer",
					"edit": "Modifier",
					"apply": "Appliquer les confirmés",
					"applying": "Application…",
					"extracting": "Extraction…",
					"status": {
						"PENDING": "En attente",
						"CONFIRMED": "Confirmé",
						"EDITED": "Modifié",
						"IGNORED": "Ignoré",
						"CUSTOM": "Custom"
					},
					"errors": {
						"extract": "Impossible d'extraire le PDF.",
						"apply": "Impossible d'appliquer l'extraction.",
						"patch": "Impossible de mettre à jour la revue."
					}
				},
				"addExam": "Ajouter un examen",
				"addExamHintVisit": "Pour ajouter des examens liés à une consultation, modifiez la consultation.",
				"addExamPlaceholder": "Rechercher un examen ou un panel…",
				"origin": {
					"visitHint": "Origine : consultation — champs en lecture seule"
				}
			},
			"errors": {
				"load": "Impossible de charger les examens."
			},
			"form": {
				"performedAt": "Date réalisée",
				"veterinarian": "Vétérinaire",
				"veterinarianPlaceholder": "Sélectionnez le vétérinaire",
				"vetName": "Nom du vétérinaire",
				"vetNamePlaceholder": "Nom",
				"vetCrmv": "Licence (CRMV)",
				"vetCrmvPlaceholder": "Licence",
				"clinic": "Clinique / laboratoire",
				"clinicPlaceholder": "Sélectionnez la clinique",
				"clinicName": "Nom de la clinique",
				"clinicNamePlaceholder": "Nom",
				"notes": "Notes / méthode",
				"notesPlaceholder": "Méthode, laboratoire, notes…",
				"examRequests": "Examens et panneaux",
				"examRequestsPlaceholder": "Sélectionnez examens ou panneaux",
				"valuesTitle": "Valeurs",
				"valuesHint": "Renseignez les valeurs maintenant ou plus tard dans le détail. Chaque valeur est enregistrée individuellement.",
				"valueNum": "Valeur numérique",
				"valueText": "Valeur (texte)",
				"upload": "Pièces jointes du résultat",
				"success": {
					"create": "Résultat d’analyse enregistré.",
					"update": "Résultat d’analyse mis à jour."
				},
				"errors": {
					"load": "Impossible de charger le formulaire d’examens.",
					"save": "Impossible d’enregistrer le résultat d’analyse.",
					"examsOrUpload": "Sélectionnez au moins un examen/panneau ou joignez un fichier."
				}
			},
			"filters": {
				"statusLabel": "Statut",
				"statusPlaceholder": "Filtrer par statut",
				"originLabel": "Origine",
				"originPlaceholder": "Manuel ou consultation",
				"examLabel": "Examen / panel",
				"examPlaceholder": "Rechercher par examen, panel ou item (ex. : Monocytes)"
			}
		},
		"petAccess": {
			"title": "Accès vétérinaires",
			"loading": "Chargement des accès",
			"fallbackInvite": "Invitation",
			"invite": {
				"title": "Inviter un vétérinaire",
				"nameLabel": "Nom",
				"namePlaceholder": "Ex : Dr Ana",
				"emailLabel": "E-mail",
				"emailPlaceholder": "email@exemple.com",
				"submit": "Envoyer l'invitation",
				"hint": "Le vétérinaire recevra un lien pour accepter l'accès.",
				"sent": "Invitation envoyée.",
				"resent": "Invitation renvoyée."
			},
			"filters": {
				"searchLabel": "Recherche",
				"searchPlaceholder": "Filtrer par nom ou e-mail",
				"kindLabel": "Type",
				"kindPlaceholder": "Lequel",
				"kindAccess": "Accès",
				"kindInvite": "Invitations",
				"kindClearAria": "Effacer le type",
				"statusLabel": "Statut",
				"statusPlaceholder": "Statut",
				"statusClearAria": "Effacer le statut",
				"onlyActiveAccess": "Afficher uniquement les accès actifs"
			},
			"status": {
				"active": "Actif",
				"blocked": "Bloqué",
				"pending": "En attente",
				"expired": "Expiré",
				"accepted": "Accepté",
				"revoked": "Annulé",
				"vetRejected": "Refusé par le vétérinaire"
			},
			"columns": {
				"name": "Nom",
				"kind": "Type",
				"email": "E-mail",
				"status": "Statut",
				"actions": "Actions"
			},
			"empty": {
				"title": "Aucun vétérinaire ou invitation trouvé",
				"description": "Invitez un vétérinaire à suivre la santé de votre animal."
			},
			"noResults": {
				"title": "Aucun résultat trouvé",
				"description": "Essayez d'ajuster les filtres pour trouver ce que vous cherchez."
			},
			"actions": {
				"activateAria": "Activer l'accès",
				"blockAria": "Bloquer l'accès",
				"unblockAria": "Débloquer l'accès",
				"removeAria": "Supprimer l'accès",
				"cancelInviteAria": "Annuler l'invitation",
				"resendInviteAria": "Renvoyer l'invitation"
			},
			"modal": {
				"cancel": "Annuler"
			},
			"revokeInvite": {
				"title": "Annuler l'invitation ?",
				"contentWithEmail": "Voulez-vous vraiment annuler l'invitation pour \"{email}\" ?",
				"contentGeneric": "Voulez-vous vraiment annuler cette invitation ?",
				"confirm": "Annuler l'invitation",
				"success": "Invitation annulée."
			},
			"removeAccess": {
				"title": "Supprimer l'accès ?",
				"contentWithName": "Voulez-vous vraiment supprimer l'accès de \"{name}\" ?",
				"contentGeneric": "Voulez-vous vraiment supprimer cet accès ?",
				"confirm": "Supprimer",
				"success": "Accès supprimé."
			},
			"errors": {
				"load": "Impossible de charger les accès.",
				"invite": "Impossible d'envoyer l'invitation.",
				"inviteAlreadySent": "Cet animal a déjà une invitation en attente pour cet e-mail.",
				"alreadyHasAccess": "Cet e-mail a déjà accès à cet animal.",
				"resend": "Impossible de renvoyer l'invitation.",
				"updateStatus": "Impossible de mettre à jour l'accès.",
				"revokeInvite": "Impossible d'annuler l'invitation.",
				"removeAccess": "Impossible de supprimer l'accès."
			}
		},
		"settings": {
			"shared": {
				"species": {
					"dog": "Chien",
					"cat": "Chat",
					"dog_cat": "Chien et Chat",
					"other": "Autre"
				},
				"sex": {
					"male": "Mâle",
					"female": "Femelle",
					"notDeclared": "Non renseigné"
				},
				"examKinds": {
					"BLOOD": "Sang",
					"URINE": "Urine",
					"FECES": "Selles",
					"IMAGE": "Imagerie",
					"CYTOLOGY": "Cytologie",
					"HISTOPATHOLOGY": "Histopathologie",
					"MICROBIOLOGY": "Microbiologie",
					"RAPID_TEST": "Test rapide",
					"GENETIC": "Génétique",
					"CARDIOLOGY": "Cardiologie",
					"OTHER": "Autre"
				},
				"fasting": {
					"NO": "Non",
					"YES": "Oui",
					"PREFERRED": "De préférence oui",
					"NOT_APPLICABLE": "Non applicable",
					"VARIABLE": "Variable",
					"NAO": "Non",
					"SIM": "Oui",
					"PREFERENCIALMENTE_SIM": "De préférence oui"
				},
				"labSpecies": {
					"DOG": "Chien",
					"CAT": "Chat"
				},
				"labTestStatuses": {
					"DRAFT": "Brouillon",
					"ACTIVE": "Actif",
					"INACTIVE": "Inactif",
					"DEPRECATED": "Obsolète"
				},
				"resultTypes": {
					"NUMERIC": "Numérique",
					"QUALITATIVE": "Qualitatif",
					"ORDINAL": "Ordinal",
					"BOOLEAN": "Booléen",
					"TEXT": "Texte",
					"REPORT": "Compte rendu",
					"COMPOSITE": "Composite",
					"UNSPECIFIED": "Non spécifié"
				}
			},
			"vaccineTypes": {
				"close": "Fermer",
				"loading": "Chargement du catalogue de vaccins",
				"tabs": {
					"aria": "Catalogue de vaccins",
					"kinds": "Types",
					"brands": "Marques",
					"products": "Produits",
					"others": "Autres"
				},
				"yes": "Oui",
				"no": "Non",
				"active": "Actif",
				"inactive": "Inactif",
				"filters": {
					"showDeleted": "Afficher les supprimés"
				},
				"actions": {
					"delete": "Supprimer",
					"deleteAria": "Supprimer l'élément du catalogue",
					"restore": "Restaurer",
					"restoreAria": "Restaurer l'élément du catalogue",
					"cancel": "Annuler"
				},
				"delete": {
					"title": "Supprimer l'élément du catalogue ?",
					"content": "Cela marquera \"{name}\" comme supprimé. Il n'apparaîtra plus dans les listes par défaut.",
					"success": "Élément supprimé."
				},
				"restore": {
					"title": "Restaurer l'élément du catalogue ?",
					"content": "Cela restaurera \"{name}\" dans les listes par défaut.",
					"success": "Élément restauré."
				},
				"errors": {
					"delete": "Impossible de supprimer l'élément.",
					"restore": "Impossible de restaurer l'élément."
				},
				"kinds": {
					"loading": "Chargement des types",
					"form": {
						"createTitle": "Enregistrer un type de vaccin",
						"editTitle": "Modifier le type de vaccin",
						"codeLabel": "Code",
						"codePlaceholder": "Ex. : RABIES",
						"nameLabel": "Nom par défaut",
						"boosterGroupLabel": "Groupe de rappel",
						"boosterGroupPlaceholder": "Sélectionnez le groupe",
						"boosterGroupOther": "Autre (saisir le code)",
						"boosterGroupOtherCodeLabel": "Code du groupe",
						"boosterGroupOtherCodePlaceholder": "Ex. : canine-polyvalent",
						"speciesLabel": "Espèces",
						"diseasesLabel": "Maladies couvertes",
						"diseasesPlaceholder": "Sélectionnez les maladies",
						"diseasesEmpty": "Aucune maladie trouvée",
						"isOtherLabel": "Type « Autre »",
						"alertsEnabledLabel": "Générer des alertes de rappel",
						"activeLabel": "Actif",
						"descriptionLabel": "Description",
						"descriptionPlaceholder": "Écrivez la description",
						"save": "Enregistrer",
						"cancel": "Annuler"
					},
					"filters": {
						"nameLabel": "Recherche",
						"namePlaceholder": "Code ou nom",
						"speciesLabel": "Espèce",
						"speciesPlaceholder": "Espèce",
						"speciesClearAria": "Effacer l'espèce"
					},
					"columns": {
						"code": "Code",
						"name": "Nom",
						"boosterGroup": "Groupe de rappel",
						"species": "Espèces",
						"diseases": "Maladies",
						"isOther": "Autre",
						"active": "Actif",
						"actions": "Actions"
					},
					"empty": {
						"title": "Aucun type enregistré",
						"description": "Enregistrez les types de vaccin du système."
					},
					"noResults": {
						"title": "Aucun type trouvé",
						"description": "Essayez d'ajuster les filtres pour trouver ce que vous cherchez."
					},
					"actions": {
						"editAria": "Modifier le type"
					},
					"errors": {
						"load": "Impossible de charger les types de vaccin.",
						"save": "Impossible d'enregistrer le type de vaccin.",
						"speciesRequired": "Sélectionnez au moins une espèce.",
						"boosterGroupRequired": "Indiquez le groupe de rappel."
					},
					"boosterGroups": {
						"canine-polyvalent": "Polyvalent canin",
						"feline-polyvalent": "Polyvalent félin"
					}
				},
				"brands": {
					"loading": "Chargement des marques",
					"form": {
						"createTitle": "Enregistrer une marque",
						"editTitle": "Modifier la marque",
						"nameLabel": "Nom",
						"activeLabel": "Active",
						"save": "Enregistrer",
						"cancel": "Annuler"
					},
					"filters": {
						"nameLabel": "Recherche",
						"namePlaceholder": "Nom de la marque"
					},
					"columns": {
						"name": "Nom",
						"active": "Active",
						"actions": "Actions"
					},
					"empty": {
						"title": "Aucune marque enregistrée",
						"description": "Enregistrez les marques commerciales de vaccins."
					},
					"noResults": {
						"title": "Aucune marque trouvée",
						"description": "Essayez d'ajuster les filtres pour trouver ce que vous cherchez."
					},
					"actions": {
						"editAria": "Modifier la marque"
					},
					"errors": {
						"load": "Impossible de charger les marques.",
						"save": "Impossible d'enregistrer la marque."
					}
				},
				"products": {
					"loading": "Chargement des produits",
					"form": {
						"createTitle": "Enregistrer un produit",
						"editTitle": "Modifier le produit",
						"kindLabel": "Type",
						"kindPlaceholder": "Sélectionnez le type",
						"brandLabel": "Marque",
						"brandPlaceholder": "Sélectionnez la marque",
						"nameLabel": "Nom commercial",
						"speciesLabel": "Espèces",
						"isOtherLabel": "Produit « Autre »",
						"activeLabel": "Actif",
						"notesLabel": "Observations",
						"notesPlaceholder": "Écrivez des observations",
						"save": "Enregistrer",
						"cancel": "Annuler"
					},
					"filters": {
						"nameLabel": "Recherche",
						"namePlaceholder": "Nom commercial",
						"kindLabel": "Type",
						"kindPlaceholder": "Type",
						"kindClearAria": "Effacer le type",
						"speciesLabel": "Espèce",
						"speciesPlaceholder": "Espèce",
						"speciesClearAria": "Effacer l'espèce"
					},
					"columns": {
						"name": "Nom commercial",
						"kind": "Type",
						"brand": "Marque",
						"species": "Espèces",
						"isOther": "Autre",
						"active": "Actif",
						"actions": "Actions"
					},
					"empty": {
						"title": "Aucun produit enregistré",
						"description": "Enregistrez les produits commerciaux de vaccins."
					},
					"noResults": {
						"title": "Aucun produit trouvé",
						"description": "Essayez d'ajuster les filtres pour trouver ce que vous cherchez."
					},
					"actions": {
						"editAria": "Modifier le produit"
					},
					"errors": {
						"load": "Impossible de charger les produits.",
						"save": "Impossible d'enregistrer le produit.",
						"speciesRequired": "Sélectionnez au moins une espèce."
					}
				},
				"others": {
					"loading": "Chargement de la file des autres",
					"filters": {
						"statusLabel": "Statut"
					},
					"status": {
						"open": "Ouverts",
						"promoted": "Promus",
						"dismissed": "Rejetés",
						"all": "Tous"
					},
					"columns": {
						"type": "Type",
						"rawText": "Texte",
						"applicationCount": "Occurrences",
						"actions": "Actions"
					},
					"typeKind": "Type de vaccin",
					"typeProduct": "Produit",
					"actions": {
						"promote": "Promouvoir",
						"dismiss": "Rejeter"
					},
					"form": {
						"codeLabel": "Code",
						"nameLabel": "Nom par défaut",
						"commercialNameLabel": "Nom commercial",
						"kindLabel": "Type de vaccin",
						"kindPlaceholder": "Sélectionnez le type",
						"speciesLabel": "Espèces",
						"cancel": "Annuler",
						"confirmPromote": "Confirmer"
					},
					"empty": {
						"title": "Aucun élément dans la file",
						"description": "Les textes libres de vaccin apparaîtront ici pour révision."
					},
					"noResults": {
						"title": "Aucun élément trouvé",
						"description": "Essayez d'ajuster le filtre de statut."
					},
					"errors": {
						"load": "Impossible de charger la file des autres.",
						"dismiss": "Impossible de rejeter l'élément.",
						"promote": "Impossible de promouvoir l'élément.",
						"speciesRequired": "Sélectionnez au moins une espèce.",
						"kindRequired": "Sélectionnez le type de vaccin."
					}
				}
			},
			"diseases": {
				"close": "Fermer",
				"loading": "Chargement des maladies",
				"form": {
					"createTitle": "Enregistrer une maladie",
					"editTitle": "Modifier la maladie",
					"codeLabel": "Code",
					"codePlaceholder": "Ex. : RABIES",
					"nameLabel": "Nom par défaut",
					"activeLabel": "Active",
					"save": "Enregistrer",
					"cancel": "Annuler"
				},
				"filters": {
					"nameLabel": "Recherche",
					"namePlaceholder": "Code ou nom",
					"showDeleted": "Afficher les supprimées"
				},
				"columns": {
					"code": "Code",
					"name": "Nom",
					"active": "Active",
					"actions": "Actions"
				},
				"empty": {
					"title": "Aucune maladie enregistrée",
					"description": "Enregistrez des maladies pour les lier aux vaccins, diagnostics et conditions."
				},
				"noResults": {
					"title": "Aucune maladie trouvée",
					"description": "Essayez d’ajuster les filtres pour trouver ce que vous cherchez."
				},
				"actions": {
					"editAria": "Modifier la maladie",
					"delete": "Supprimer",
					"deleteAria": "Supprimer la maladie",
					"restore": "Restaurer",
					"restoreAria": "Restaurer la maladie",
					"cancel": "Annuler"
				},
				"delete": {
					"title": "Supprimer la maladie ?",
					"content": "Cela marquera \"{name}\" comme supprimée.",
					"success": "Maladie supprimée."
				},
				"restore": {
					"title": "Restaurer la maladie ?",
					"content": "Cela restaurera \"{name}\".",
					"success": "Maladie restaurée."
				},
				"errors": {
					"load": "Impossible de charger les maladies.",
					"save": "Impossible d’enregistrer la maladie.",
					"delete": "Impossible de supprimer la maladie.",
					"restore": "Impossible de restaurer la maladie."
				}
			},
			"breeds": {
				"title": "Races et pelage",
				"subtitle": "Consultez les races, gérez les couleurs de pelage et révisez les textes libres marqués comme « Autre »",
				"close": "Fermer l'alerte",
				"tabs": {
					"aria": "Sections des races",
					"catalog": "Races",
					"reference": "Pelage",
					"others": "Autres"
				},
				"catalog": {
					"loading": "Chargement des races",
					"filters": {
						"species": "Espèce",
						"search": "Recherche",
						"searchPlaceholder": "Nom ou code"
					},
					"columns": {
						"code": "Code",
						"name": "Nom",
						"group": "Groupe"
					},
					"empty": {
						"title": "Aucune race trouvée",
						"description": "Ajustez les filtres ou sélectionnez une autre espèce."
					},
					"noResults": {
						"title": "Aucun résultat",
						"description": "Aucune race ne correspond aux filtres actuels."
					},
					"errors": {
						"load": "Impossible de charger les races.",
						"save": "Impossible d'enregistrer la race.",
						"codeExists": "Une race avec ce code existe déjà pour cette espèce."
					},
					"saveSuccess": "Race enregistrée avec succès.",
					"form": {
						"createTitle": "Enregistrer une race",
						"speciesLabel": "Espèce",
						"codeLabel": "Code",
						"codePlaceholder": "ex. : LABRADOR",
						"nameLabel": "Nom",
						"namePlaceholder": "Nom affiché",
						"save": "Enregistrer"
					}
				},
				"colors": {
					"loading": "Chargement des couleurs",
					"filterTipo": "couleurs",
					"saveSuccess": "Couleur enregistrée avec succès.",
					"deleteSuccess": "Couleur supprimée avec succès.",
					"restoreSuccess": "Couleur restaurée avec succès.",
					"filters": {
						"search": "Recherche",
						"searchPlaceholder": "Nom ou code",
						"showDeleted": "Afficher les supprimées"
					},
					"form": {
						"createTitle": "Enregistrer une nouvelle couleur",
						"editTitle": "Modifier la couleur",
						"codeLabel": "Code",
						"codePlaceholder": "ex. : merle",
						"nameLabel": "Nom",
						"namePlaceholder": "Nom affiché",
						"sortOrderLabel": "Ordre",
						"activeLabel": "Active",
						"save": "Enregistrer",
						"cancel": "Annuler"
					},
					"columns": {
						"code": "Code",
						"name": "Nom",
						"sortOrder": "Ordre",
						"active": "Active",
						"actions": "Actions"
					},
					"actions": {
						"editAria": "Modifier la couleur",
						"deleteAria": "Supprimer la couleur",
						"restoreAria": "Restaurer la couleur",
						"delete": "Supprimer",
						"restore": "Restaurer",
						"cancel": "Annuler"
					},
					"delete": {
						"title": "Supprimer la couleur",
						"content": "Supprimer la couleur « {{name}} » ? Les animaux qui l'utilisent déjà conservent la valeur enregistrée."
					},
					"restore": {
						"title": "Restaurer la couleur",
						"content": "Restaurer la couleur « {{name}} » ?"
					},
					"empty": {
						"title": "Aucune couleur",
						"description": "Ajoutez la première couleur de pelage."
					},
					"noResults": {
						"title": "Aucun résultat",
						"description": "Aucune couleur ne correspond aux filtres actuels."
					},
					"errors": {
						"load": "Impossible de charger les couleurs.",
						"save": "Impossible d'enregistrer la couleur.",
						"delete": "Impossible de supprimer la couleur.",
						"restore": "Impossible de restaurer la couleur."
					}
				},
				"others": {
					"loading": "Chargement de la file de revue",
					"filters": {
						"species": "Espèce",
						"status": "Statut",
						"allSpecies": "Toutes les espèces"
					},
					"columns": {
						"text": "Texte saisi",
						"species": "Espèce",
						"pets": "Animaux",
						"status": "Statut",
						"actions": "Actions"
					},
					"status": {
						"open": "Ouvert",
						"promoted": "Promu",
						"dismissed": "Rejeté",
						"all": "Tous"
					},
					"actions": {
						"promote": "Promouvoir",
						"dismiss": "Rejeter"
					},
					"promote": {
						"code": "Code",
						"name": "Nom",
						"species": "Espèce",
						"create": "Créer la race",
						"linkExisting": "Lier à une race existante",
						"link": "Lier",
						"cancel": "Annuler"
					},
					"empty": {
						"title": "File vide",
						"description": "Les textes libres marqués comme « Autre » apparaîtront ici pour révision."
					},
					"noResults": {
						"title": "Aucun résultat",
						"description": "Aucun élément ne correspond aux filtres actuels."
					},
					"promoteSuccess": "Race promue avec succès.",
					"dismissSuccess": "Élément rejeté.",
					"errors": {
						"load": "Impossible de charger la file de revue.",
						"promote": "Impossible de promouvoir cet élément.",
						"dismiss": "Impossible de rejeter cet élément."
					}
				}
			},
			"examTypes": {
				"close": "Fermer",
				"loading": "Chargement des types d'examen",
				"disclaimer": "Les valeurs de référence sont informatives et ne remplacent pas l'évaluation clinique.",
				"form": {
					"createTitle": "Créer un type d'examen",
					"editTitle": "Modifier le type d'examen",
					"nameLabel": "Nom courant",
					"namePlaceholder": "Ex. : Glucose, SDMA, ALT",
					"officialNameLabel": "Nom officiel",
					"officialNamePlaceholder": "Ex. : Glucose sérique",
					"codeLabel": "Code",
					"codePlaceholder": "Ex. : GLU-SER",
					"categoryLabel": "Catégorie (texte legacy)",
					"categoryIdLabel": "Catégorie",
					"categoryIdPlaceholder": "Sélectionner la catégorie",
					"subcategoryIdLabel": "Sous-catégorie",
					"subcategoryIdPlaceholder": "Sélectionner la sous-catégorie",
					"speciesLabel": "Espèce",
					"speciesPlaceholder": "Espèce",
					"speciesCodesLabel": "Espèces applicables",
					"speciesRequiredError": "Sélectionnez au moins une espèce.",
					"examKindLabel": "Type d'examen",
					"examKindPlaceholder": "Type d'examen",
					"statusLabel": "Statut",
					"resultTypeLabel": "Type de résultat",
					"aliasesLabel": "Alias / synonymes",
					"aliasesPlaceholder": "Séparés par des virgules",
					"tagsLabel": "Tags",
					"tagsPlaceholder": "Séparés par des virgules",
					"resultOptionsLabel": "Options qualitatives",
					"resultOptionsPlaceholder": "Ex. : Négatif, Positif, Indéterminé",
					"replacementLabel": "Examen de remplacement (obsolète)",
					"replacementPlaceholder": "Sélectionner l'examen canonique",
					"unitLabel": "Unité",
					"refDogTitle": "Référence — chien",
					"refCatTitle": "Référence — chat",
					"refLowLabel": "Minimum",
					"refHighLabel": "Maximum",
					"refTextLabel": "Texte de référence",
					"refNotesLabel": "Notes de référence",
					"fastingRequiredLabel": "Jeûne requis ?",
					"fastingRequiredPlaceholder": "Jeûne",
					"fastingTimeLabel": "Durée du jeûne",
					"fastingTimePlaceholder": "Ex. : 8 à 12 heures",
					"fastingMinLabel": "Jeûne min (min)",
					"fastingMaxLabel": "Jeûne max (min)",
					"descriptionLabel": "Description",
					"descriptionPlaceholder": "Description technique",
					"preparationInformationLabel": "Informations de préparation",
					"preparationInformationPlaceholder": "Consignes de préparation du patient",
					"additionalInfoLabel": "Informations du catalogue",
					"additionalInfoPlaceholder": "Notes pour le catalogue...",
					"reviewRequiredLabel": "Révision requise",
					"routineLabel": "Routine",
					"sortOrderLabel": "Ordre d'affichage",
					"save": "Enregistrer",
					"cancel": "Annuler",
					"softDelete": "Supprimer (désactiver)",
					"deactivate": "Supprimer (désactiver)",
					"saveSuccess": "Type d'examen enregistré avec succès.",
					"updateSuccess": "Type d'examen mis à jour avec succès.",
					"softDeleteSuccess": "Type d'examen supprimé (désactivé).",
					"deactivateSuccess": "Type d'examen supprimé (désactivé)."
				},
				"filters": {
					"nameLabel": "Nom de l'examen",
					"namePlaceholder": "Nom (courant ou officiel)",
					"speciesLabel": "Espèce",
					"speciesPlaceholder": "Espèce",
					"speciesClearAria": "Effacer l'espèce",
					"examKindLabel": "Type d'examen",
					"statusLabel": "Statut",
					"includeInactive": "Inclure inactifs",
					"includeDeprecated": "Inclure obsolètes"
				},
				"columns": {
					"name": "Nom",
					"officialName": "Nom officiel",
					"status": "Statut",
					"species": "Espèce",
					"examKind": "Type d'examen",
					"unit": "Unité",
					"reference": "Référence",
					"category": "Catégorie",
					"additionalInfo": "Infos additionnelles",
					"actions": "Actions"
				},
				"empty": {
					"title": "Aucun type d'examen enregistré",
					"description": "Enregistrez des types d'examen pour les rendre disponibles."
				},
				"noResults": {
					"title": "Aucun type d'examen trouvé",
					"description": "Essayez d'ajuster les filtres."
				},
				"actions": {
					"editAria": "Modifier le type d'examen",
					"duplicateAria": "Dupliquer le type d'examen",
					"softDeleteAria": "Supprimer le type d'examen"
				},
				"errors": {
					"load": "Impossible de charger les types d'examen.",
					"save": "Impossible d'enregistrer le type d'examen.",
					"softDelete": "Impossible de supprimer le type d'examen.",
					"deactivate": "Impossible de supprimer le type d'examen."
				}
			},
			"examPanels": {
				"close": "Fermer",
				"loading": "Chargement des panels d'examen",
				"form": {
					"createTitle": "Créer un panel d'examen",
					"editTitle": "Modifier le panel d'examen",
					"nameLabel": "Nom du panel",
					"officialNameLabel": "Nom officiel",
					"officialNamePlaceholder": "Nom officiel du panel",
					"codeLabel": "Code",
					"codePlaceholder": "Ex. : PANEL-BIOQ",
					"statusLabel": "Statut",
					"speciesLabel": "Espèce (legacy)",
					"speciesPlaceholder": "Espèce",
					"speciesCodesLabel": "Espèces applicables",
					"speciesRequiredError": "Sélectionnez au moins une espèce.",
					"examKindLabel": "Type d'examen",
					"examKindPlaceholder": "Type d'examen",
					"categoryIdLabel": "Catégorie",
					"categoryIdPlaceholder": "Sélectionner la catégorie",
					"fastingRequiredLabel": "Jeûne requis ?",
					"fastingRequiredPlaceholder": "Jeûne",
					"fastingTimeLabel": "Durée du jeûne",
					"fastingTimePlaceholder": "Ex. : 8 à 12 heures",
					"fastingMinLabel": "Jeûne min (min)",
					"fastingMaxLabel": "Jeûne max (min)",
					"descriptionLabel": "Description",
					"descriptionPlaceholder": "Description du panel",
					"reviewRequiredLabel": "Révision requise",
					"sortOrderLabel": "Ordre d'affichage",
					"itemsTitle": "Examens inclus dans le panel",
					"itemTypeLabel": "Type d'examen",
					"itemTypePlaceholder": "Sélectionner le type d'examen",
					"itemTypeEmpty": "Aucun type d'examen disponible",
					"itemRequiredLabel": "Obligatoire",
					"itemDefaultLabel": "Sélectionné par défaut",
					"addItem": "Ajouter au panel",
					"itemsEmpty": "Aucun examen ajouté au panel.",
					"tagRequired": "Obligatoire",
					"tagDefault": "Sélectionné par défaut",
					"saveSuccess": "Panel d'examen enregistré avec succès.",
					"updateSuccess": "Panel d'examen mis à jour avec succès.",
					"softDelete": "Supprimer (désactiver)",
					"softDeleteSuccess": "Panel d'examen supprimé (désactivé).",
					"removeItem": "Retirer",
					"moveItemUp": "Déplacer l'examen vers le haut",
					"moveItemDown": "Déplacer l'examen vers le bas",
					"save": "Enregistrer",
					"cancel": "Annuler"
				},
				"filters": {
					"nameLabel": "Nom du panel",
					"namePlaceholder": "Nom du panel",
					"speciesLabel": "Espèce",
					"speciesPlaceholder": "Espèce",
					"speciesClearAria": "Effacer l'espèce",
					"examKindLabel": "Type d'examen",
					"examKindPlaceholder": "Type d'examen",
					"examKindClearAria": "Effacer le type d'examen",
					"statusLabel": "Statut",
					"includeInactive": "Inclure inactifs",
					"includeDeprecated": "Inclure obsolètes"
				},
				"columns": {
					"name": "Nom",
					"species": "Espèce",
					"examKind": "Type d'examen",
					"status": "Statut",
					"itemsCount": "Nb d'examens",
					"description": "Description",
					"actions": "Actions"
				},
				"empty": {
					"title": "Aucun panel d'examen enregistré",
					"description": "Enregistrez des panels pour rendre les examens disponibles."
				},
				"noResults": {
					"title": "Aucun panel trouvé",
					"description": "Essayez d'ajuster les filtres."
				},
				"actions": {
					"editAria": "Modifier le panel d'examen",
					"softDeleteAria": "Supprimer le panel d'examen"
				},
				"errors": {
					"load": "Impossible de charger les panels d'examen.",
					"save": "Impossible d'enregistrer le panel d'examen.",
					"softDelete": "Impossible de supprimer le panel d'examen."
				}
			},
			"exams": {
				"tabs": {
					"aria": "Sections d’administration des examens",
					"catalog": "Catalogue",
					"panels": "Panneaux",
					"audit": "Audit",
					"imports": "Importations",
					"auditComingSoon": "L’audit des examens sera disponible à une étape ultérieure.",
					"importsComingSoon": "Les importations tableur/PDF seront disponibles aux étapes suivantes."
				},
				"audit": {
					"disclaimer": "Révisez les examens demandés comme « Autre ». Créer ou fusionner promeut au catalogue officiel et relié les demandes ; rejeter conserve le texte original sans promotion.",
					"loading": "Chargement de la file d’audit",
					"createSuccess": "Type officiel créé et entrée résolue.",
					"mergeSuccess": "Entrée fusionnée au type officiel.",
					"rejectSuccess": "Entrée rejetée.",
					"reopenSuccess": "Entrée rouverte pour révision.",
					"mergeTargetAria": "Type officiel à fusionner",
					"mergeTargetPlaceholder": "Rechercher un examen officiel…",
					"filters": {
						"status": "Statut",
						"q": "Recherche",
						"qPlaceholder": "Nom d’origine"
					},
					"columns": {
						"name": "Nom d’origine",
						"status": "Statut",
						"kind": "Type suggéré",
						"official": "Officiel",
						"updatedAt": "Mis à jour",
						"actions": "Actions"
					},
					"actions": {
						"create": "Créer officiel",
						"merge": "Fusionner",
						"reject": "Rejeter",
						"reopen": "Rouvrir"
					},
					"status": {
						"pending": "En attente",
						"created": "Créé",
						"merged": "Fusionné",
						"rejected": "Rejeté",
						"all": "Tous"
					},
					"empty": {
						"title": "Aucune entrée",
						"description": "Lorsque les tuteurs demandent des examens hors catalogue, ils apparaissent ici."
					},
					"errors": {
						"load": "Impossible de charger l’audit.",
						"create": "Impossible de créer le type officiel.",
						"merge": "Impossible de fusionner l’entrée.",
						"mergeTarget": "Indiquez l’ID du type officiel pour fusionner.",
						"reject": "Impossible de rejeter l’entrée.",
						"reopen": "Impossible de rouvrir l’entrée."
					},
					"mergeTargetEmpty": "Aucun examen trouvé"
				},
				"imports": {
					"disclaimer": "Importez le catalogue en CSV ou JSON, révisez les classifications et appliquez les actions par ligne. Le modèle v1 n’inclut pas XLSX.",
					"loading": "Chargement des importations",
					"uploadSuccess": "Fichier envoyé et classé avec succès.",
					"actionsSaved": "Actions des lignes enregistrées.",
					"applySuccess": "Importation appliquée avec succès.",
					"emptyRows": "Aucune ligne dans cette importation.",
					"columns": {
						"filename": "Fichier",
						"status": "Statut",
						"totals": "Résumé",
						"createdAt": "Créé le",
						"actions": "Actions"
					},
					"actions": {
						"downloadTemplate": "Télécharger le modèle",
						"upload": "Envoyer un fichier",
						"saveRows": "Enregistrer les actions",
						"apply": "Appliquer l’importation",
						"openAria": "Ouvrir le détail de l’importation",
						"create": "Créer",
						"update": "Mettre à jour",
						"ignore": "Ignorer",
						"link": "Lier"
					},
					"status": {
						"readyForReview": "Prêt pour révision",
						"processing": "Traitement",
						"applied": "Appliqué",
						"failed": "Échec",
						"cancelled": "Annulé"
					},
					"classification": {
						"new": "Nouveau",
						"identical": "Identique",
						"different": "Différent",
						"possibleDuplicate": "Doublon possible",
						"invalid": "Invalide"
					},
					"empty": {
						"title": "Aucune importation",
						"description": "Téléchargez le modèle et envoyez un CSV ou JSON pour commencer."
					},
					"errors": {
						"load": "Impossible de charger les importations.",
						"template": "Impossible de télécharger le modèle.",
						"upload": "Impossible d’envoyer le fichier.",
						"detail": "Impossible d’ouvrir le détail de l’importation.",
						"saveRows": "Impossible d’enregistrer les actions des lignes.",
						"apply": "Impossible d’appliquer l’importation."
					},
					"hints": {
						"create": "Suggestion : créer dans le catalogue",
						"update": "Suggestion : mettre à jour l'examen correspondant",
						"link": "Suggestion : lier / vérifier le doublon",
						"ignore": "Suggestion : ignorer"
					},
					"compare": {
						"matched": "Correspond à",
						"field": "Champ",
						"incoming": "Importé",
						"catalog": "Catalogue actuel",
						"fields": {
							"code": "Code",
							"name": "Nom",
							"officialName": "Nom officiel",
							"examKind": "Type",
							"status": "Statut",
							"resultType": "Type de résultat",
							"unit": "Unité",
							"refLow": "Réf. min",
							"refHigh": "Réf. max",
							"category": "Catégorie",
							"fastingRequirement": "Jeûne",
							"description": "Description",
							"additionalInfo": "Info supplémentaire",
							"species": "Espèces"
						}
					},
					"actionHelp": {
						"createHelp": "Crée un nouvel examen dans le catalogue avec les données Importées.",
						"updateHelp": "Remplace l’examen correspondant du catalogue par les valeurs Importées.",
						"ignoreHelp": "Ne modifie pas le catalogue ; la ligne importée est ignorée.",
						"linkHelp": "Pas encore vraiment implémenté (se comporte comme Ignorer). Indiquez le comportement souhaité."
					}
				}
			},
			"systemUsers": {
				"loading": "Chargement des utilisateurs",
				"filters": {
					"searchLabel": "Rechercher",
					"searchPlaceholder": "Nom, e-mail, téléphone",
					"roleLabel": "Type",
					"rolePlaceholder": "Tous",
					"roleClearAria": "Effacer le type",
					"showDeleted": "Afficher les supprimés"
				},
				"roles": {
					"user": "Propriétaire",
					"vet": "Vétérinaire",
					"master": "Master"
				},
				"status": {
					"active": "Actif",
					"pendingVerification": "En attente de vérification",
					"blocked": "Bloqué",
					"deleted": "Supprimé"
				},
				"columns": {
					"name": "Nom",
					"email": "E-mail",
					"role": "Type",
					"pets": "Animaux",
					"status": "Statut",
					"createdAt": "Créé",
					"actions": "Actions"
				},
				"empty": {
					"title": "Aucun utilisateur enregistré",
					"description": "Des utilisateurs apparaîtront bientôt ici ! :)"
				},
				"noResults": {
					"title": "Aucun utilisateur trouvé",
					"description": "Essayez d'ajuster les filtres pour trouver ce que vous cherchez."
				},
				"actions": {
					"restoreAria": "Restaurer l'utilisateur",
					"deleteForeverAria": "Supprimer définitivement",
					"blockAria": "Bloquer l'utilisateur",
					"unblockAria": "Débloquer l'utilisateur",
					"deleteAria": "Supprimer l'utilisateur",
					"resendVerificationAria": "Renvoyer l'e-mail de vérification"
				},
				"modal": {
					"cancel": "Annuler"
				},
				"delete": {
					"title": "Supprimer l'utilisateur",
					"content": "Cela marquera l'utilisateur comme supprimé et désactivera ses animaux (soft delete). Continuer ?\n\n{name}\n{email}",
					"confirm": "Supprimer"
				},
				"deleteForever": {
					"title": "Supprimer définitivement",
					"content": "Cette action est permanente et supprime l'utilisateur de la base.\n\n{name}\n{email}",
					"confirm": "Supprimer définitivement"
				},
				"restore": {
					"title": "Restaurer l'utilisateur",
					"content": "Cela restaurera l'utilisateur et les animaux désactivés avec cette suppression. Continuer ?\n\n{name}\n{email}",
					"confirm": "Restaurer"
				},
				"success": {
					"resendVerification": "E-mail de vérification renvoyé."
				},
				"errors": {
					"load": "Impossible de charger les utilisateurs.",
					"updateStatus": "Impossible de mettre à jour le statut de l'utilisateur.",
					"delete": "Impossible de supprimer l'utilisateur.",
					"deleteForever": "Impossible de supprimer définitivement l'utilisateur.",
					"restore": "Impossible de restaurer l'utilisateur.",
					"resendVerification": "Impossible de renvoyer l'e-mail de vérification."
				}
			},
			"audit": {
				"loading": "Chargement de l'audit",
				"filters": {
					"sourceLabel": "Source",
					"sourceAuth": "Authentification",
					"sourceActions": "Actions administratives",
					"emailLabel": "E-mail",
					"emailPlaceholder": "Filtrer par e-mail",
					"eventLabel": "Événement",
					"eventPlaceholder": "Filtrer par événement",
					"actionLabel": "Action",
					"actionPlaceholder": "Filtrer par action",
					"entityTypeLabel": "Type d'entité",
					"entityTypePlaceholder": "Filtrer par type d'entité"
				},
				"columns": {
					"event": "Événement",
					"email": "E-mail",
					"userId": "Utilisateur",
					"action": "Action",
					"entityType": "Type",
					"entityId": "ID entité",
					"entityName": "Entité",
					"actorUserId": "ID acteur",
					"actorName": "Acteur",
					"ip": "IP",
					"country": "Pays",
					"createdAt": "Date",
					"actions": "Actions"
				},
				"empty": {
					"title": "Aucun enregistrement d'audit",
					"description": "Les journaux d'authentification et d'actions administratives apparaîtront ici."
				},
				"noResults": {
					"title": "Aucun enregistrement trouvé",
					"description": "Essayez d'ajuster les filtres pour trouver ce que vous cherchez."
				},
				"actions": {
					"metadataAria": "Voir les métadonnées"
				},
				"metadata": {
					"title": "Métadonnées",
					"close": "Fermer"
				},
				"errors": {
					"load": "Impossible de charger les enregistrements d'audit."
				}
			},
			"dashboard": {
				"close": "Fermer",
				"loading": "Chargement du tableau de bord",
				"refreshing": "Mise à jour des données…",
				"tabs": {
					"aria": "Onglets du tableau de bord admin",
					"pets": "Animaux",
					"vaccines": "Vaccins",
					"others": "Autres",
					"exams": "Examens"
				},
				"period": {
					"from": "Du",
					"to": "Au",
					"apply": "Appliquer",
					"petsHint": "Filtre par la période d'enregistrement et le tuteur. Mise à jour automatique.",
					"vaccinesHint": "Filtre par la période d'application du vaccin. Mise à jour automatique.",
					"examsHint": "Filtre les examens réalisés par la date du résultat (resulted_at / performed_at). Mise à jour automatique."
				},
				"stats": {
					"petsTotal": "Total d'animaux",
					"petsActive": "Animaux actifs",
					"withMicrochip": "Avec micropuce",
					"withoutMicrochip": "Sans micropuce",
					"weighedRecent": "Pesés au cours des 6 derniers mois",
					"weighedStale": "Sans pesée depuis +6 mois",
					"neverWeighed": "Jamais pesés",
					"applicationsTotal": "Applications",
					"petsVaccinated": "Animaux vaccinés",
					"resultsTotal": "Examens réalisés",
					"petsWithResults": "Animaux avec examens",
					"panelResultsTotal": "Éléments de panneaux",
					"typeResultsTotal": "Examens isolés"
				},
				"filters": {
					"title": "Filtres",
					"tutor": "Tuteur",
					"allTutors": "Tout le système",
					"species": "Espèce",
					"allSpecies": "Toutes les espèces",
					"examKind": "Type d'examen",
					"allExamKinds": "Tous les types",
					"category": "Catégorie",
					"allCategories": "Toutes les catégories",
					"petSearch": "Rechercher un animal",
					"petSearchPlaceholder": "Nom de l'animal"
				},
				"charts": {
					"bySpecies": "Par espèce",
					"byAge": "Par tranche d'âge",
					"byGender": "Par sexe",
					"byBreed": "Par race",
					"byBreedEmpty": "Aucun animal avec une race enregistrée pour le filtre actuel.",
					"byWeightStatus": "Par statut de pesée",
					"byWeightStatusEmpty": "Pas de données de pesée pour le filtre actuel.",
					"byCreatedMonth": "Inscriptions par mois",
					"byPetSpecies": "Animaux vaccinés par espèce",
					"byMonth": "Applications par mois",
					"byKind": "Par type de vaccin",
					"byContext": "Par contexte d'application",
					"byLocationType": "Par type de lieu",
					"applicationsSeries": "Applications",
					"registrationsSeries": "Inscriptions",
					"axis": {
						"species": "Espèce",
						"gender": "Sexe",
						"breed": "Race",
						"month": "Mois",
						"kind": "Type de vaccin",
						"context": "Contexte",
						"locationType": "Type de lieu",
						"count": "Quantité",
						"examKind": "Type d'examen",
						"category": "Catégorie"
					},
					"examsByPetSpecies": "Animaux avec examens par espèce",
					"resultsByMonth": "Examens réalisés par mois",
					"resultsByMonthEmpty": "Aucun examen réalisé pour la période filtrée.",
					"byExamKind": "Par type d'examen",
					"byExamCategory": "Par catégorie du catalogue",
					"byExamCategoryEmpty": "Aucune catégorie disponible pour le filtre actuel.",
					"resultsSeries": "Examens réalisés"
				},
				"age": {
					"puppy": "Chiot / chaton",
					"adult": "Adulte",
					"senior": "Senior",
					"unknown": "Inconnu",
					"hint": "Définition des tranches d'âge :",
					"puppyHint": "Chiot / chaton : jusqu’à 11 mois",
					"adultHint": "Adulte : de 1 an jusqu’à 6 ans et 11 mois",
					"seniorHint": "Senior : 7 ans ou plus",
					"unknownHint": "Inconnu : sans date de naissance"
				},
				"labels": {
					"unknown": "Non renseigné"
				},
				"others": {
					"empty": "Aucun élément dans la file",
					"emptyTitle": "File à jour",
					"openFullQueue": "Ouvrir la file complète",
					"promoteSuccess": "Élément promu avec succès.",
					"dismissSuccess": "Élément écarté avec succès.",
					"applications": "Applications",
					"typeKind": "Type",
					"typeProduct": "Produit",
					"dismiss": "Écarter",
					"promote": "Promouvoir",
					"cancel": "Annuler",
					"confirmPromote": "Confirmer",
					"codeLabel": "Code",
					"defaultNameLabel": "Nom par défaut",
					"commercialNameLabel": "Nom commercial",
					"kindLabel": "Type de vaccin",
					"kindPlaceholder": "Sélectionnez le type",
					"speciesLabel": "Espèces"
				},
				"errors": {
					"load": "Impossible de charger le tableau de bord.",
					"loadPets": "Impossible de charger le tableau de bord des animaux.",
					"loadVaccines": "Impossible de charger le tableau de bord des vaccins.",
					"loadOthers": "Impossible de charger la file de révision.",
					"dismiss": "Impossible d'écarter l'élément.",
					"promote": "Impossible de promouvoir l'élément.",
					"speciesRequired": "Sélectionnez au moins une espèce.",
					"kindRequired": "Sélectionnez le type de vaccin.",
					"loadExams": "Impossible de charger le tableau de bord des examens."
				},
				"petsTable": {
					"title": "Animaux avec examens réalisés",
					"subtitle": "{{total}} animal(aux) dans le filtre actuel",
					"emptyTitle": "Aucun animal trouvé",
					"empty": "Aucun animal avec examens réalisés pour les filtres sélectionnés.",
					"openExams": "Ouvrir les examens",
					"prev": "Précédent",
					"next": "Suivant",
					"page": "Page {{page}} sur {{total}}",
					"columns": {
						"pet": "Animal",
						"species": "Espèce",
						"results": "Résultats",
						"lastResult": "Dernier résultat",
						"actions": "Actions"
					}
				}
			},
			"myData": {
				"saveSuccess": "Données enregistrées avec succès.",
				"saveFailed": "Impossible d'enregistrer. Réessayez.",
				"loadFailed": "Impossible de charger vos données.",
				"loading": "Chargement de vos données…",
				"clearColor": "Restaurer la couleur par défaut",
				"tabsAria": "Onglets mes données",
				"tabs": {
					"profile": "Données personnelles",
					"alerts": "Notifications"
				},
				"form": {
					"fullNameLabel": "Nom complet",
					"fullNamePlaceholder": "Votre nom complet",
					"preferredNameLabel": "Nom préféré",
					"preferredNamePlaceholder": "Comment vous préférez être appelé(e)",
					"emailLabel": "E-mail",
					"emailPlaceholder": "vous@exemple.com",
					"phoneLabel": "Téléphone",
					"phonePlaceholder": "(11) 99999-9999",
					"themeColorLabel": "Couleur du système",
					"themeColorTooltip": "Couleur pour une utilisation personnalisée dans le système. Modifiez ci-dessous pour tester. Cliquez sur enregistrer pour sauvegarder."
				},
				"push": {
					"title": "Push notifications",
					"description": "Receive glucose curve alerts on this device (pet owner only). Best with installed PWA.",
					"enable": "Enable notifications",
					"disable": "Disable notifications",
					"enabled": "Notifications enabled.",
					"disabled": "Notifications disabled.",
					"failed": "Could not change notifications.",
					"unsupported": "Ce navigateur ne prend pas en charge Web Push."
				},
				"alerts": {
					"hiddenTitle": "Masquer les alertes",
					"hiddenDescription": "Choisissez quels types d'alerte ne doivent pas apparaître dans la liste, l'aperçu ou la page d'alertes.",
					"saveSuccess": "Préférences d'alertes enregistrées.",
					"saveFailed": "Impossible d'enregistrer les préférences d'alertes.",
					"hideKind": {
						"preventive": "Masquer l'alerte : Préventifs",
						"vaccine": "Masquer l'alerte : Vaccins",
						"glycemia": "Masquer l'alerte : Glycémie",
						"treatment": "Masquer l'alerte : Traitements",
						"visit": "Masquer l'alerte : Consultations",
						"weight": "Masquer l'alerte : Poids",
						"birthday": "Masquer l'alerte : Anniversaires"
					}
				}
			}
		}
	},
	"settings": {
		"preventives": {
			"tabs": {
				"brands": "Fabricants",
				"products": "Produits"
			},
			"active": "Actif",
			"showDeleted": "Afficher les supprimés",
			"filters": {
				"search": "Rechercher"
			},
			"actions": "Actions",
			"edit": "Modifier",
			"delete": "Supprimer",
			"cancel": "Annuler",
			"brands": {
				"name": "Fabricant",
				"createTitle": "Ajouter un fabricant",
				"editTitle": "Modifier le fabricant"
			},
			"products": {
				"name": "Nom commercial",
				"brand": "Fabricant",
				"category": "Catégorie",
				"method": "Méthode",
				"species": "Espèces",
				"protectionValue": "Durée de protection",
				"protectionUnit": "Période",
				"aliases": "Alias (séparés par des virgules)",
				"isOther": "Autre produit",
				"notes": "Notes",
				"createTitle": "Ajouter un produit",
				"editTitle": "Modifier le produit"
			},
			"empty": {
				"brands": {
					"title": "Aucun fabricant enregistré",
					"description": "Ajoutez le premier fabricant du catalogue."
				},
				"products": {
					"title": "Aucun produit enregistré",
					"description": "Ajoutez le premier produit du catalogue."
				}
			},
			"noResults": {
				"title": "Aucun résultat trouvé",
				"description": "Essayez d'ajuster les filtres pour trouver ce que vous cherchez."
			},
			"errors": {
				"load": "Impossible de charger le catalogue.",
				"save": "Impossible d’enregistrer le catalogue.",
				"species": "Sélectionnez au moins une espèce.",
				"delete": "Impossible de supprimer l’élément."
			},
			"success": {
				"save": "Catalogue enregistré.",
				"delete": "Élément supprimé."
			}
		}
	},
	"breeds": {
		"notInformed": "Non renseigné",
		"breedPlaceholder": "Sélectionner la race",
		"otherBreedLabel": "Description de la race",
		"otherBreedPlaceholder": "Indiquez la race",
		"coatLabel": "Pelage",
		"coatLengthLabel": "Longueur du pelage",
		"coatColorsLabel": "Couleurs du pelage",
		"coatColorsSearch": "Rechercher une couleur",
		"otherColorLabel": "Autre couleur",
		"otherColorPlaceholder": "Décrivez la couleur",
		"lengths": {
			"hairless": "Sans poil",
			"short": "Courte",
			"medium": "Moyenne",
			"long": "Longue"
		},
		"colors": {
			"white": "Blanc",
			"black": "Noir",
			"gray": "Gris",
			"silver": "Argent",
			"blue": "Bleu",
			"brown": "Marron",
			"chocolate": "Chocolat",
			"liver": "Foie",
			"tan": "Tan",
			"cream": "Crème",
			"beige": "Beige",
			"fawn": "Fauve",
			"yellow": "Jaune",
			"golden": "Doré",
			"orange": "Orange",
			"red": "Rouge",
			"cinnamon": "Cannelle",
			"lilac": "Lilas",
			"caramel": "Caramel",
			"sable": "Sable",
			"smoke": "Smoke",
			"other": "Autre"
		}
	},
	"infos": {
		"photo": "Photo",
		"selectPhoto": "Sélectionner une photo",
		"removePhoto": "Supprimer la photo",
		"name": "Nom",
		"age": "Âge",
		"birth": "Naissance",
		"adoptionTime": "Temps d’adoption",
		"adoptionDate": "Date d’adoption",
		"specie": "Espèce",
		"race": "Race",
		"sex": "Sexe",
		"coat": "Pelage",
		"microchip": "Microchip",
		"microchipAbsent": "Pas de puce électronique",
		"themeColor": "Couleur de l’animal dans l’application",
		"themeColorTooltip": "Couleur pour une utilisation personnalisée dans le système. Modifiez ci-dessous pour tester. Il faut cliquer sur enregistrer pour sauvegarder l'information.",
		"photoUpload": {
			"selected": "Photo « {{fileName}} » sélectionnée. Cliquez sur enregistrer pour sauvegarder.",
			"dropzone": "Glissez-déposez la photo ici",
			"dropActive": "Déposez la photo pour l’envoyer",
			"browse": "ou cliquez pour parcourir",
			"constraints": "Formats acceptés : JPG, PNG, WebP jusqu’à 5 Mo",
			"disabled": "Téléversement de photo désactivé",
			"uploading": "Envoi de la photo...",
			"existingMeta": "Image animal",
			"cropAction": "Modifier l’image (recadrer)",
			"cancelUploadAria": "Annuler l’envoi",
			"removeFileAria": "Supprimer le fichier",
			"invalidFileType": "Type de fichier non autorisé",
			"fileTooLarge": "Le fichier dépasse la taille maximale (__MAX_SIZE__)",
			"uploadFailed": "Impossible d’envoyer le fichier",
			"unknownExtension": "FICHIER",
			"cropper": {
				"title": "Recadrer l’image",
				"cancel": "Annuler",
				"apply": "Appliquer le recadrage",
				"zoom": "Zoom",
				"ratio": "Proportion",
				"rotateLeftAria": "Pivoter à gauche",
				"rotateRightAria": "Pivoter à droite",
				"aspectFree": "Libre",
				"aspectSquare": "Carré (1:1)",
				"aspectFourThree": "4:3",
				"aspectSixteenNine": "16:9"
			}
		},
		"previewExpand": "Agrandir l’image",
		"healthCare": {
			"success": "Santé et soins mis à jour avec succès.",
			"errors": {
				"genericTitle": "Erreur lors de l’enregistrement",
				"genericMessage": "Impossible d’enregistrer les informations de santé et de soins. Veuillez réessayer."
			},
			"neuteredStatus": {
				"label": "Stérilisé",
				"options": {
					"yes": "Oui",
					"no": "Non",
					"unknown": "Inconnu"
				}
			},
			"castrationDate": {
				"label": "Date de stérilisation"
			},
			"origin": {
				"label": "Origine de l’animal",
				"options": {
					"breeder": "Éleveur",
					"shelter": "Refuge / ONG",
					"rescue": "Sauvetage",
					"born_at_home": "Né à la maison",
					"other": "Autre"
				}
			},
			"originOther": {
				"label": "Origine — Autre",
				"placeholder": "Décrivez l’origine de l’animal"
			},
			"livingEnvironment": {
				"label": "Environnement de vie",
				"options": {
					"indoor_only": "Intérieur — uniquement à l’intérieur",
					"outdoor_yard_only": "Extérieur — uniquement dehors (jardin)",
					"outdoor_yard_street_access": "Extérieur — dehors (jardin + accès libre à la rue)",
					"mixed_no_street_access": "Mixte — dedans et dehors sans accès libre à la rue",
					"mixed_with_street_access": "Mixte — dedans et dehors avec accès libre à la rue"
				}
			},
			"allergies": {
				"label": "Allergies",
				"placeholder": "Décrivez les allergies connues de l'animal (médicaments, aliments, environnementales, etc.)"
			},
			"feeding": {
				"label": "Alimentation",
				"placeholder": "Nom de la nourriture ou régime habituel",
				"labelTooltip": "Nom de la croquette ou décrivez l'alimentation quotidienne de l'animal, comme une alimentation naturelle et ce qu'il mange"
			}
		},
		"new": {
			"title": "Créer un animal",
			"subtitle": "Remplissez les informations ci-dessous pour enregistrer votre animal dans le système"
		},
		"time": {
			"and": "et",
			"year": "{count, plural, one {# an} other {# ans}}",
			"month": "{count, plural, one {# mois} other {# mois}}",
			"day": "{count, plural, one {# jour} other {# jours}}"
		}
	},
	"loading": {
		"trying": "Chargement...",
		"noResults": "Aucune information trouvée",
		"endOfList": "Fin des résultats"
	},
	"menu": {
		"expand": "Développer le menu",
		"collapse": "Réduire le menu",
		"language": {
			"label": "Langue",
			"ariaLabel": "Langue actuelle",
			"options": {
				"pt": "Portugais",
				"en": "Anglais",
				"es": "Espagnol",
				"fr": "Français"
			}
		},
		"principal": {
			"title": "Animaux",
			"profiles": {
				"master": {
					"title": "Gestion des animaux",
					"subtitle": "Gérez vos animaux et consultez ceux d’autres propriétaires si nécessaire"
				},
				"vet": {
					"title": "Animaux partagés avec moi",
					"subtitle": "Suivez les animaux autorisés par les propriétaires et consultez leur historique"
				},
				"user": {
					"title": "Mes animaux",
					"subtitle": "Suivez vos animaux, alertes et informations importantes au même endroit"
				}
			},
			"type": "pet",
			"petsList": "Liste des animaux",
			"alerts": "Alertes",
			"registerPet": "Enregistrer un animal"
		},
		"pet": {
			"title": "Animal",
			"overview": {
				"title": "Vue d’ensemble",
				"subtitle": "Résumé des informations de santé et de soins de l’animal"
			},
			"alerts": {
				"title": "Alertes",
				"subtitle": "Alertes et éléments en attente pour cet animal"
			},
			"edit": {
				"title": "Modifier l’animal",
				"subtitle": "Mettez à jour les informations de base de votre animal",
				"tabs": {
					"general": "Informations Générales",
					"healthCare": "Santé et soins",
					"feeding": "Alimentation",
					"access": "Accès",
					"aria": "Sections de modification de l’animal"
				},
				"success": "Animal mis à jour avec succès.",
				"errors": {
					"conflictTitle": "Enregistrement impossible",
					"conflictMessage": "Un enregistrement avec ces données existe déjà.",
					"invalidTitle": "Données invalides",
					"invalidMessage": "Vérifiez les champs et réessayez.",
					"forbiddenTitle": "Permission refusée",
					"forbiddenMessage": "Votre session a peut-être expiré. Veuillez vous reconnecter.",
					"photoTooLargeTitle": "Photo trop volumineuse",
					"photoTooLargeMessage": "L’image dépasse la limite de 5 Mo. Choisissez un fichier plus petit.",
					"photoTypeTitle": "Format non pris en charge",
					"photoTypeMessage": "Utilisez une image JPG, PNG ou WebP.",
					"genericTitle": "Erreur lors de l’enregistrement",
					"genericMessage": "Veuillez réessayer dans un instant."
				}
			},
			"new": {
				"success": "Animal enregistré avec succès.",
				"errors": {
					"conflictTitle": "Enregistrement impossible",
					"conflictMessage": "Un enregistrement avec ces données existe déjà.",
					"invalidTitle": "Données invalides",
					"invalidMessage": "Vérifiez les champs et réessayez.",
					"forbiddenTitle": "Permission refusée",
					"forbiddenMessage": "Votre session a peut-être expiré. Veuillez vous reconnecter.",
					"photoTooLargeTitle": "Photo trop volumineuse",
					"photoTooLargeMessage": "L’image dépasse la limite de 5 Mo. Choisissez un fichier plus petit.",
					"photoTypeTitle": "Format non pris en charge",
					"photoTypeMessage": "Utilisez une image JPG, PNG ou WebP.",
					"genericTitle": "Erreur lors de l’enregistrement de l’animal",
					"genericMessage": "Veuillez réessayer dans un instant."
				}
			},
			"weight": {
				"title": "Poids",
				"subtitle": "Historique des pesées et évolution du poids"
			},
			"preventives": {
				"title": "Préventifs",
				"subtitle": "Contrôle des antiparasitaires et vermifuges",
				"type": "Préventif",
				"new": "Nouvel enregistrement",
				"newSubtitle": "Enregistrez l’application d’un préventif",
				"edit": "Modifier l’enregistrement",
				"editSubtitle": "Mettez à jour les données du préventif"
			},
			"veterinaryConsultation": {
				"title": "Consultations",
				"subtitle": "Historique des consultations vétérinaires",
				"type": "Consultation",
				"new": "Nouvelle visite chez le vétérinaire",
				"newSubtitle": "Enregistrez la consultation et les principaux constats cliniques",
				"edit": "Modifier la visite chez le vétérinaire",
				"editSubtitle": "Mettez à jour les informations de la consultation"
			},
			"vaccines": {
				"title": "Vaccins",
				"subtitle": "Enregistrement des vaccins administrés à l’animal",
				"type": "Vaccin",
				"new": "Nouvelle administration de vaccin",
				"newSubtitle": "Indiquez le contexte, le lieu et les données d’application",
				"edit": "Modifier l'administration du vaccin",
				"editSubtitle": "Mettez à jour les données d’administration du vaccin"
			},
			"examsResults": {
				"title": "Résultats d’analyses",
				"subtitle": "Résultats et historique des examens demandés lors des consultations",
				"type": "Analyses",
				"new": "Nouveau résultat d’analyse",
				"newSubtitle": "Enregistrez des examens historiques avec date, valeurs et pièces jointes",
				"edit": "Modifier le résultat d’analyse",
				"editSubtitle": "Mettez à jour les données de la demande et les valeurs"
			},
			"examsResultsDetails": {
				"title": "Détails des résultats de l'examen",
				"subtitle": "Informations sur l'examen réalisé"
			},
			"examsComparisons": {
				"title": "Comparaisons d’analyses",
				"subtitle": "Évolution et plage de référence",
				"type": "Analyses"
			},
			"treatments": {
				"title": "Traitements",
				"subtitle": "Traitements continus ou temporaires",
				"type": "Traitement",
				"new": "Nouveau traitement",
				"newSubtitle": "Enregistrez un traitement en cours ou temporaire",
				"edit": "Modifier le traitement",
				"editSubtitle": "Mettez à jour les informations du traitement",
				"view": "Voir le traitement",
				"viewSubtitle": "Plan terminé — seules les notes peuvent être ajoutées"
			},
			"clinicalConditions": {
				"title": "Conditions cliniques",
				"subtitle": "Maladies et conditions de santé suivies",
				"type": "Condition",
				"details": "Affection clinique: {name}",
				"detailsSubtitle": "Suivez l’historique et les notes de cette condition",
				"new": "Nouvelle affection clinique",
				"newSubtitle": "Enregistrez une condition clinique de l’animal",
				"edit": "Modifier l'affection clinique",
				"editSubtitle": "Mettez à jour les données de la condition clinique"
			},
			"glucoseCurveMeasures": {
				"title": "Mesures glycémiques",
				"subtitle": "Suivi des mesures de la courbe glycémique",
				"type": "Mesure",
				"new": "Nouvelle mesure de la courbe glycémique",
				"newSubtitle": "Enregistrez une nouvelle session de courbe glycémique",
				"details": "Mesure du {date}",
				"detailsFallback": "Mesure",
				"detailsSubtitle": "Détails et points de la courbe glycémique"
			},
			"glucoseCurveComparison": {
				"title": "Comparaison glycémique",
				"subtitle": "Évolution de la glycémie dans le temps",
				"type": "Mesure"
			},
			"glycemia": {
				"title": "Glycémie",
				"subtitle": "Suivi quotidien, courbe et comparaison"
			}
		},
		"vet": {
			"title": "Mes animaux partagés",
			"subtitle": "Choisissez un animal pour consulter ses informations et son historique"
		},
		"admin": {
			"title": "Administration",
			"dashboard": "Dashboard",
			"dashboardSubtitle": "Vue d'ensemble des animaux, applications de vaccins et file de révision",
			"typesOfVaccines": "Vaccin",
			"typesOfVaccinesSubtitle": "Types, marques, produits et file de révision des textes libres",
			"preventivesCatalog": "Préventifs",
			"preventivesCatalogSubtitle": "Marques et produits préventifs",
			"diseases": "Maladies",
			"diseasesSubtitle": "Enregistrez et gérez les maladies liées aux vaccins et conditions",
			"breeds": "Races",
			"breedsSubtitle": "Races, couleurs de pelage et file de révision",
			"exams": "Examens",
			"examsSubtitle": "Catalogue, panneaux, audit et importations d’examens",
			"typesOfExams": "Types d’analyses",
			"typesOfExamsSubtitle": "Enregistrez les types d’examen et les références du système",
			"examinationPackage": "Forfaits d’analyses",
			"examinationPackageSubtitle": "Composez des forfaits avec des ensembles d’examens",
			"adminUsers": "Utilisateurs du système",
			"adminUsersSubtitle": "Gérez les tuteurs, vétérinaires et statuts d’accès",
			"audit": "Audit",
			"auditSubtitle": "Journaux d'authentification et d'actions administratives",
			"myDataSubtitle": "Données personnelles et préférences de notification"
		},
		"fixed": {
			"myData": "Mon compte",
			"mySettings": "Mes paramètres",
			"logout": "Se déconnecter"
		},
		"goBackTo": {
			"principal": "Retour aux animaux"
		}
	},
	"overview": {
		"microchipAbsent": "Aucune",
		"titles": {
			"infos": "Informations sur les animaux de compagnie",
			"nextVaccines": "Vaccins à venir",
			"lastWeighIns": "Dernières pesées",
			"glycemicCurve": "Courbe de glycémie",
			"glycemicCurveComparison": "Comparaison des courbes les plus récentes"
		},
		"fields": {
			"microchip": "Puce électronique"
		},
		"weights": {
			"from": "Du",
			"to": "Au",
			"startDate": "Date de début",
			"endDate": "Date de fin",
			"dateAxis": "Date",
			"weightAxis": "Poids (kg)",
			"lastWeighIn": "Dernière pesée :",
			"onDate": "le",
			"noRecords": "Aucun enregistrement",
			"gained": "a pris",
			"lost": "a perdu",
			"maintained": "a maintenu",
			"inPeriod": "sur la période.",
			"open": "Enregistrer / Voir les poids",
			"errors": {
				"endBeforeStart": "La date de fin ne peut pas être antérieure à la date de début.",
				"sameDates": "Les dates ne peuvent pas être identiques. Sélectionnez-en deux différentes."
			}
		},
		"glycemia": {
			"measurementDate": "Date de la mesure :",
			"minimum": "Min :",
			"maximum": "Max :",
			"average": "Moyenne :",
			"clicks": "clics",
			"register": "Enregistrer la glycémie",
			"viewMeasurement": "Voir la mesure effectuée"
		},
		"completeness": {
			"title": "Informations manquantes",
			"lead": "Champs de base importants encore non renseignés pour cet animal :",
			"badgeOk": "Complet",
			"badgeMissing": "{count} en attente",
			"emptyTitle": "Toutes les informations de base importantes sont renseignées",
			"emptyDescription": "Profil général, santé/soins, vaccins et poids sont OK pour cet animal.",
			"vaccinesTotal": "Vaccins enregistrés",
			"weightsTotal": "Pesées enregistrées",
			"fields": {
				"microchip": "Puce électronique",
				"birthDate": "Date de naissance",
				"adoptionDate": "Date d’adoption",
				"breed": "Race",
				"coatLength": "Longueur du pelage",
				"coatColors": "Couleur du pelage",
				"neuteredStatus": "Castré (oui / non / inconnu)",
				"castrationDate": "Date de castration",
				"origin": "Origine de l’animal",
				"livingEnvironment": "Environnement de vie",
				"feeding": "Alimentation",
				"vaccines": "Aucun vaccin enregistré",
				"weights": "Aucune pesée enregistrée"
			}
		}
	},
	"toast": {
		"successTitle": "Succès !",
		"errorTitle": "Erreur !",
		"warningTitle": "Attention",
		"infoTitle": "Information"
	},
	"uiKit": {
		"form": {
			"selectPlaceholder": "Sélectionner",
			"searchPlaceholder": "Rechercher...",
			"searchAriaLabel": "Rechercher une option",
			"emptyOptions": "Aucune option trouvée",
			"clearSelectionAria": "Effacer la sélection"
		},
		"table": {
			"paginationAria": "Pagination du tableau",
			"paginationTopSuffix": "(haut)",
			"paginationBottomSuffix": "(bas)",
			"previous": "Précédent",
			"next": "Suivant",
			"first": "Première",
			"last": "Dernière",
			"page": "Page",
			"of": "sur",
			"total": "enregistrement(s)",
			"pageSizeAria": "Éléments par page",
			"sortBy": "Trier par __COLUMN__",
			"sortAsc": "croissant",
			"sortDesc": "décroissant"
		},
		"modal": {
			"confirm": "Confirmer",
			"cancel": "Annuler",
			"close": "Fermer",
			"closeAria": "Fermer la fenêtre"
		},
		"toast": {
			"closeAria": "Fermer la notification"
		},
		"loading": {
			"ariaLabel": "Chargement du contenu"
		},
		"tabs": {
			"ariaLabel": "Onglets"
		},
		"breadcrumb": {
			"ariaLabel": "Fil d'Ariane"
		},
		"switch": {
			"active": "Activé",
			"inactive": "Désactivé"
		},
		"button": {
			"loading": "Chargement..."
		},
		"alert": {
			"closeAria": "Fermer l'alerte"
		},
		"fileUpload": {
			"pdfBadge": "pdf"
		}
	},
	"vaccines": {
		"kinds": {
			"BORDETELLA": "Bordetella",
			"FELV": "FeLV",
			"GIARDIA": "Giardia",
			"LEISHMANIASIS": "Leishmaniose",
			"CANINE_PUPPY": "Puppy",
			"RABIES": "Rage",
			"TOSSE": "Toux et grippe canine",
			"CANINE_V10": "V10",
			"CANINE_V11": "V11",
			"FELINE_V3": "V3",
			"FELINE_V4": "V4",
			"FELINE_V5": "V5",
			"CANINE_V6": "V6",
			"CANINE_V8": "V8",
			"OTHER": "Autre"
		},
		"diseases": {
			"RABIES": "Rage",
			"CANINE_DISTEMPER": "Maladie de Carré",
			"CANINE_ADENOVIRUS": "Adénovirus / Hépatite",
			"CANINE_PARVOVIRUS": "Parvovirose",
			"CANINE_PARAINFLUENZA": "Parainfluenza",
			"LEPTOSPIROSIS": "Leptospirose",
			"BORDETELLA": "Bordetella / Toux du chenil",
			"GIARDIA": "Giardia",
			"LEISHMANIASIS": "Leishmaniose",
			"FELINE_HERPESVIRUS": "Herpèsvirus félin",
			"FELINE_CALICIVIRUS": "Calicivirus félin",
			"FELINE_PANLEUKOPENIA": "Panleucopénie féline",
			"FELINE_CHLAMYDIA": "Chlamydiose féline",
			"FELINE_LEUKEMIA": "Leucémie féline (FeLV)"
		},
		"dose": {
			"unique": "unique",
			"nth": "{n}ᵉ dose",
			"last": "dernière dose"
		},
		"product": {
			"notInformed": "Non renseignée"
		},
		"context": {
			"consultation": "Consultation vétérinaire",
			"home": "Soins à domicile",
			"campaign": "Campagne publique",
			"shelter_ngo": "ONG / Refuge",
			"hospital": "Hôpital vétérinaire",
			"breeder": "Éleveur (chenil/cattery)",
			"university": "Université",
			"other": "Autre"
		},
		"visitType": {
			"routine": "Routine",
			"return": "Suivi",
			"emergency": "Urgence"
		},
		"visitMode": {
			"in_person": "Présentiel",
			"home": "Domicile",
			"tele": "Téléconsultation"
		},
		"locationType": {
			"clinic": "Clinique",
			"home": "Domicile",
			"public_event": "Événement / campagne",
			"shelter": "Refuge / ONG",
			"hospital": "Hôpital",
			"breeder": "Éleveur",
			"university": "Université",
			"pet_shop": "Animalerie",
			"other": "Autre"
		},
		"form": {
			"kindLabel": "Type de vaccin",
			"kindPlaceholder": "Sélectionnez le type…",
			"productLabel": "Produit / marque commerciale",
			"productPlaceholder": "Sélectionnez le produit…",
			"otherKindLabel": "Nom du type",
			"otherKindPlaceholder": "Indiquez le type de vaccin",
			"otherProductLabel": "Nom du produit",
			"otherProductPlaceholder": "Indiquez le produit",
			"doseLabel": "Dose",
			"contextLabel": "Contexte d'application",
			"contextPlaceholder": "Sélectionnez le contexte…",
			"locationNameLabel": "Lieu",
			"locationNamePlaceholder": "Rechercher une clinique ou un lieu",
			"clinicOther": "Autre",
			"clinicNameLabel": "Nom du lieu",
			"clinicNamePlaceholder": "Ex. : Clinique X, refuge…",
			"homeLocationFixed": "Domicile",
			"visitTypeLabel": "Type de consultation",
			"visitTypePlaceholder": "Sélectionnez le type…",
			"visitModeLabel": "Mode de consultation",
			"visitModePlaceholder": "Sélectionnez le mode…",
			"weightLabel": "Poids (kg)",
			"weightPlaceholder": "Ex. : 4,5",
			"weightReplaceTitle": "Remplacer le poids du jour ?",
			"weightReplaceDescription": "Un poids de {existing} kg existe déjà pour ce jour. Le remplacer par {next} kg ?",
			"weightReplaceConfirm": "Remplacer",
			"weightReplaceSkip": "Conserver le poids actuel",
			"visitLabel": "Consultation liée",
			"visitPlaceholder": "Sélectionnez la consultation…",
			"administeredAtLabel": "Administré le",
			"administeredAtTimeLabel": "Heure",
			"nextDoseLabel": "Prochaine dose",
			"administeredByLabel": "Professionnel",
			"vetCrmvLabel": "CRMV",
			"vetCrmvPlaceholder": "Ex. : CRMV-SP 12345",
			"clinicLabel": "Clinique",
			"notesLabel": "Observations / effets",
			"notesPlaceholder": "Notez réactions, effets ou complications…",
			"visitInternalNotes": "Application de vaccin",
			"kindOrProductHint": "Vous pouvez choisir le type, le produit, ou seulement le produit — le type est rempli automatiquement.",
			"dosesSingular": "1 dose",
			"dosesPlural": "{count} doses",
			"successSave": "Vaccin enregistré avec succès.",
			"errorSave": "Impossible d’enregistrer le vaccin. Réessayez.",
			"addVaccine": "Ajouter un vaccin",
			"removeVaccine": "Retirer le vaccin",
			"sectionTitle": "Vaccins administrés",
			"vaccinesSectionHint": "Pour chaque vaccin administré ce jour-là, indiquez le type, le produit et la date de la prochaine dose.",
			"cancel": "Annuler"
		}
	},
	"preventives": {
		"form": {
			"loading": "Chargement du préventif…",
			"appliedAtLabel": "Date d'application",
			"kindLabel": "Lequel",
			"kindPlaceholder": "Sélectionnez…",
			"methodLabel": "Type",
			"methodPlaceholder": "Sélectionnez…",
			"productLabel": "Produit",
			"productPlaceholder": "Ex. : NexGard, Bravecto…",
			"productCatalogPlaceholder": "Rechercher un produit…",
			"otherProduct": "Autre / non répertorié",
			"otherProductLabel": "Nom du produit",
			"protectionValueLabel": "Durée de protection",
			"protectionValuePlaceholder": "Ex. : 30",
			"protectionUnitLabel": "Période",
			"protectionUnitPlaceholder": "Sélectionnez…",
			"unitDays": "Jours",
			"unitMonths": "Mois",
			"recurringLabel": "Application récurrente",
			"recurringTooltip": "Si elle est activée, crée une alerte sur l'accueil basée sur la prochaine dose.",
			"nextDueAtLabel": "Prochaine dose",
			"calculateNextDue": "Calculer la prochaine date",
			"recalculate": "Recalculer",
			"autoSuggestion": "Suggestion automatique : {date}",
			"weightLabel": "Poids du jour (kg)",
			"weightPlaceholder": "Ex. : 4,5",
			"weightReplaceTitle": "Remplacer le poids du jour ?",
			"weightReplaceDescription": "Un poids de {existing} kg existe déjà pour ce jour. Le remplacer par {next} kg ?",
			"weightReplaceConfirm": "Remplacer",
			"weightReplaceSkip": "Conserver le poids actuel",
			"notesLabel": "Observations",
			"notesPlaceholder": "Ajoutez des observations",
			"cancel": "Annuler",
			"success": {
				"create": "Préventif enregistré avec succès.",
				"update": "Préventif mis à jour avec succès."
			},
			"errors": {
				"load": "Impossible de charger le préventif.",
				"save": "Impossible d'enregistrer le préventif.",
				"recalculate": "Impossible de recalculer la prochaine dose."
			},
			"sourceTreatmentLabel": "Traitement source",
			"sourceTreatmentPlaceholder": "Lier à un traitement"
		},
		"categories": {
			"pulgas_carrapatos": "Puces et tiques",
			"pulgas": "Puces",
			"vermifugo": "Vermifuge",
			"vermifugo_dirofilariose": "Vermifuge et dirofilariose",
			"combo_interno_externo": "Protection interne et externe",
			"outro": "Autre"
		},
		"methods": {
			"comprimido": "Comprimé",
			"injecao": "Injection",
			"coleira": "Collier",
			"pipeta": "Pipette",
			"spray": "Spray",
			"shampoo": "Shampooing",
			"liquido": "Liquide",
			"pasta": "Pâte",
			"outro": "Autre"
		}
	},
	"appUpdate": {
		"title": "Nouvelle version disponible",
		"message": "Une mise à jour est prête. Actualisez pour charger les nouveaux textes et correctifs.",
		"reload": "Mettre à jour",
		"later": "Plus tard",
		"errorTitle": "Mise à jour",
		"unrecoverable": "L'application doit être rechargée pour continuer."
	},
	"offline": {
		"banner": "Pas de connexion. Les données de ce formulaire restent sur cet appareil et pourront être envoyées lorsque la connexion sera rétablie."
	},
	"weight": {
		"loading": "Chargement de l’historique des poids",
		"readOnlyInfo": "Seul le tuteur de l’animal peut ajouter ou supprimer des poids.",
		"unit": {
			"kg": "kg"
		},
		"form": {
			"panelTitle": "Enregistrer un nouveau poids"
		},
		"tabs": {
			"aria": "Vues du poids",
			"summary": "Résumé",
			"stats": "Statistiques",
			"timeline": "Chronologie"
		},
		"summary": {
			"initial": "Poids initial",
			"current": "Poids actuel",
			"last": "Dernier poids",
			"trend": "Tendance"
		},
		"trend": {
			"up": "Prise de poids",
			"down": "Perte de poids",
			"flat": "Poids stable"
		},
		"stats": {
			"loading": "Chargement des statistiques",
			"periodNote": "* Données statistiques basées sur les 12 derniers mois.",
			"insufficient": {
				"title": "Données insuffisantes",
				"description": "Il faut au moins 2 enregistrements de poids sur les 12 derniers mois pour afficher les statistiques."
			},
			"max": "Poids le plus élevé",
			"min": "Poids le plus bas",
			"average": "Poids moyen",
			"averageBasis": "Basé sur {count} enregistrements",
			"amplitude": "Amplitude",
			"amplitudeMeta": "Entre le poids le plus bas et le plus élevé",
			"lastWeighing": "Dernière pesée",
			"lastWeighingToday": "Aujourd’hui",
			"lastWeighingOneDay": "Il y a 1 jour",
			"lastWeighingDays": "Il y a {days} jours",
			"ratePerWeek": "Variation moyenne",
			"ratePerWeekMeta": "Du premier au dernier enregistrement de la période",
			"ratePerWeekValue": "{value} kg/semaine",
			"frequency": "Fréquence",
			"frequencyMeta": "Intervalle moyen entre les enregistrements",
			"frequencyDays": "Tous les {days} jours",
			"frequencyOneDay": "Quotidienne en moyenne",
			"notAvailable": "—",
			"trend": "Tendance",
			"error": {
				"title": "Impossible de charger les statistiques",
				"description": "Une erreur s’est produite lors du calcul des statistiques de poids. Réessayez.",
				"retry": "Réessayer"
			}
		},
		"timeline": {
			"sortAria": "Changer l’ordre de la chronologie",
			"sortNewest": "Plus récents d’abord",
			"sortOldest": "Plus anciens d’abord",
			"loadingMore": "Chargement d’autres enregistrements"
		},
		"empty": {
			"title": "Aucun poids enregistré",
			"description": "Suivez le développement de votre animal ! Le poids est extrêmement important !",
			"descriptionReadOnly": "Aucun poids n’est enregistré pour cet animal."
		},
		"loadError": {
			"title": "Impossible de charger les poids",
			"description": "Une erreur s’est produite lors de la récupération de l’historique des poids. Réessayez.",
			"retry": "Réessayer"
		},
		"errors": {
			"save": "Impossible d’enregistrer le poids. Réessayez.",
			"duplicateDate": "Un poids est déjà enregistré ce jour-là",
			"delete": "Impossible de supprimer l’enregistrement. Réessayez.",
			"loadMore": "Impossible de charger plus d’enregistrements."
		},
		"success": {
			"save": "Poids enregistré avec succès.",
			"delete": "Enregistrement de poids supprimé."
		},
		"delete": {
			"title": "Supprimer l’enregistrement de poids ?",
			"contentWithRecord": "Cette action est irréversible. Enregistrement : {record}",
			"contentGeneric": "Cette action est irréversible.",
			"confirm": "Supprimer",
			"cancel": "Annuler"
		},
		"actions": {
			"deleteAria": "Supprimer l’enregistrement de poids"
		}
	},
	"feeding": {
		"loading": "Chargement de l’alimentation",
		"historyTitle": "Historique",
		"changedFeeding": "J’ai changé l’alimentation",
		"stoppedFeeding": "J’ai arrêté",
		"stop": {
			"title": "Arrêter l’alimentation",
			"description": "Voulez-vous terminer « {product} » ? Elle passera dans l’historique et ne sera pas remplacée.",
			"confirm": "Arrêter",
			"cancel": "Annuler"
		},
		"history": {
			"from": "Du : {date}",
			"to": "Au : {date}"
		},
		"card": {
			"since": "Depuis {date}",
			"notesPrefix": "Obs. : "
		},
		"empty": {
			"activeTitle": "Aucune alimentation enregistrée",
			"activeDescription": "Enregistrez la nourriture ou le régime actuel de l’animal pour suivre les changements dans le temps.",
			"historyTitle": "Aucun historique",
			"historyDescription": "Lorsqu’une alimentation est remplacée, elle apparaîtra ici."
		},
		"form": {
			"titleAdd": "Ajouter un aliment",
			"titleChange": "J’ai changé l’alimentation",
			"type": "Type",
			"product": "Produit",
			"productPlaceholder": "Sélectionnez un produit du catalogue",
			"productOther": "Autre",
			"brandName": "Marque",
			"brandNamePlaceholder": "Ex. : Royal Canin",
			"productName": "Nom du produit",
			"productNamePlaceholder": "Ex. : croquettes adult, alimentation maison",
			"flavor": "Saveur",
			"flavorPlaceholder": "Ex. : poulet",
			"purpose": "Objectif",
			"format": "Format",
			"frequencyUnit": "Fréquence",
			"frequencyTimes": "Fois",
			"frequencyTimesPlaceholder": "Ex. : 2",
			"frequencyOther": "Décrire la fréquence",
			"frequencyOtherPlaceholder": "Ex. : tous les 2 jours, seulement le week-end",
			"startDate": "Date de début",
			"endDate": "Date de fin de la précédente",
			"notes": "Notes",
			"notesPlaceholder": "Ajoutez des notes"
		},
		"type": {
			"dry_food": "Croquettes",
			"wet_food": "Pâtée",
			"natural_home_cooked": "Naturelle maison",
			"natural_commercial": "Naturelle commerciale",
			"raw_diet": "Régime cru (BARF)",
			"milk_formula": "Lait / formule",
			"enteral_diet": "Alimentation entérale",
			"other": "Autre"
		},
		"purpose": {
			"maintenance": "Entretien",
			"growth": "Croissance",
			"weight_control": "Contrôle du poids",
			"therapeutic": "Thérapeutique",
			"recovery": "Récupération",
			"senior": "Senior",
			"other": "Autre"
		},
		"format": {
			"kibble": "Croquettes",
			"sachet": "Sachet",
			"can": "Boîte",
			"pate": "Pâté",
			"mousse": "Mousse",
			"frozen": "Surgelé",
			"refrigerated": "Réfrigéré",
			"dehydrated": "Déshydraté",
			"freeze_dried": "Lyophilisé",
			"liquid": "Liquide",
			"other": "Autre"
		},
		"frequency": {
			"unit": {
				"day": "Par jour",
				"week": "Par semaine",
				"free": "Libre",
				"other": "Autre"
			},
			"label": {
				"day": "{times}x par jour",
				"week": "{times}x par semaine",
				"free": "Libre (toujours disponible)"
			}
		},
		"success": {
			"create": "Aliment ajouté avec succès.",
			"change": "Alimentation mise à jour avec succès.",
			"stop": "Alimentation terminée avec succès."
		},
		"errors": {
			"loadTitle": "Chargement impossible",
			"loadMessage": "Une erreur s’est produite lors du chargement de l’alimentation. Réessayez.",
			"saveTitle": "Enregistrement impossible",
			"saveMessage": "Vérifiez les champs et réessayez.",
			"stopMessage": "Impossible de terminer l’alimentation. Réessayez."
		}
	},
	"table": {
		"totalCount": "<span class='hide-mobile'>Total de </span><strong>{ total }</strong> enregistrements"
	},
	"noResults": {
		"vaccines": "Plus de vaccins"
	}
}
